(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["element.select"] && !Shopify.designMode) return;
  try {
    // Custom element for select button functionality
  class ElementSelect extends HTMLElement {
    constructor() {
      super();
      this.select = null;
      this.buttonText = null;
      this.button = null;
    }

    connectedCallback() {
      // Wait for DOM to be ready
      this.select = this.querySelector('select');
      this.button = this.querySelector('.element-button');
      
      if (this.select && this.button) {
        this.init();
      }
    }

    init() {
      // Find the button text element within the element.button
      this.buttonText = this.button.querySelector('.element-button__text') || this.button.querySelector('[data-button-text]');
      
      // Set initial text
      this.updateButtonText();
      
      // Add click handler to button to trigger select
      this.button.addEventListener('click', (e) => this.handleButtonClick(e));
      
      // Add keyboard handler for the select element
      this.select.addEventListener('keydown', (e) => this.handleKeydown(e));
      
      // Update on change
      this.select.addEventListener('change', () => this.updateButtonText());
      
      // Update on focus for better UX
      this.select.addEventListener('focus', () => this.handleFocus());
      this.select.addEventListener('blur', () => this.handleBlur());
    }

    handleButtonClick(e) {
      // Prevent default button behavior
      e.preventDefault();
      e.stopPropagation();
      
      // Trigger the native select
      this.select.focus();
      this.select.click();
    }

    handleKeydown(e) {
      // Handle keyboard navigation for the select
      switch (e.key) {
        case 'Enter':
        case ' ':
          e.preventDefault();
          this.select.click();
          break;
        case 'ArrowDown':
        case 'ArrowUp':
          // Let the native select handle arrow key navigation
          break;
        default:
          // Let other keys pass through
          break;
      }
    }

    updateButtonText() {
      if (!this.buttonText) return;
      
      const selectedOption = this.select.options[this.select.selectedIndex];
      if (selectedOption && selectedOption.value !== '') {
        this.buttonText.textContent = selectedOption.textContent;
      } else {
        this.buttonText.textContent = this.select.getAttribute('aria-label') || 'Select an option';
      }
    }

    handleFocus() {
      this.classList.add('element-select__wrapper--focused');
    }

    handleBlur() {
      this.classList.remove('element-select__wrapper--focused');
    }

    disconnectedCallback() {
      // Clean up event listeners
      if (this.button) {
        this.button.removeEventListener('click', (e) => this.handleButtonClick(e));
      }
      if (this.select) {
        this.select.removeEventListener('keydown', (e) => this.handleKeydown(e));
        this.select.removeEventListener('change', () => this.updateButtonText());
        this.select.removeEventListener('focus', () => this.handleFocus());
        this.select.removeEventListener('blur', () => this.handleBlur());
      }
    }
  }

  // Register the custom element
  customElements.define('element-select', ElementSelect);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.product"] && !Shopify.designMode) return;
  try {
    class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.findSubmitButton();
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    findSubmitButton() {
      // Look for submit button in the form
      const submitButton = this.form.querySelector('button[type="submit"], input[type="submit"]');
      return submitButton;
    }

    disableSubmitButton() {
      if (this.submitButton) {
        this.submitButton.disabled = true;
        this.submitButton.classList.add('product-form__submit-button--pulsing');
      }
    }

    enableSubmitButton() {
      if (this.submitButton) {
        this.submitButton.disabled = false;
        this.submitButton.classList.remove('product-form__submit-button--pulsing');
      }
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();

      // Disable submit button and start pulsing
      this.disableSubmitButton();

      // Get cart state before form submission
      let cartBeforeSubmission;
      try {
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
        cartBeforeSubmission = await cartResponse.json();
      } catch (error) {
        console.error('Failed to get cart state before submission:', error);
        cartBeforeSubmission = null;
      }

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      };

      const formData = new FormData(this.form);

      // Dispatch event allowing subscribers to modify formData
      this.dispatchEvent(
        new CustomEvent('product-form:submit:before', {
          bubbles: true,
          detail: {
            form: formData,
          },
          cancelable: true
        })
      );

      // Wait for the next tick to allow async event listeners to complete
      // This ensures all synchronous and microtask listeners have finished
      await new Promise(resolve => {
        // Use queueMicrotask for better performance than setTimeout
        queueMicrotask(resolve);
      });

      config.body = formData;

      // Dispatch event allowing subscribers to handle cart request themselves
      const cartRequestEvent = new CustomEvent('product-form:cart:request', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: formData,
          config: config,
          cartBefore: cartBeforeSubmission,
          resolve: (responseData) => this.resolveCartRequest(responseData),
          reject: (error) => this.rejectCartRequest(error)
        }
      });

      const cartRequestHandled = !this.dispatchEvent(cartRequestEvent);
      let responseData;

      try {
        if (cartRequestHandled) {
          // Event was cancelled, meaning a subscriber handled the cart request
          // We need to wait for them to provide the response data
          responseData = await this.waitForCartResponse();
        } else {
          // No subscriber handled it, proceed with default behavior
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, config);       
          responseData = await response.json();

          if (!response.ok) {
            throw responseData;
          }
        }

        // Get updated cart state after form submission
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
        const cartAfterSubmission = await cartResponse.json();

        this.dispatchEvent(
          new CustomEvent('product-form:submit:success', {
            bubbles: true,
            detail: {
              form: formData,
              response: responseData,
              cart: cartAfterSubmission
            },
          })
        );

        // Only fire cart:update if there's a change from this specific submission
        if (this.hasCartChanged(cartBeforeSubmission, cartAfterSubmission)) {
          this.dispatchEvent(
            new CustomEvent('product-form:cart:update', {
              bubbles: true,
              detail: {
                cart: cartAfterSubmission,
                form: formData,
                response: responseData
              },
            })
          );
        }

        // Navigate to cart unless prevented by another event handler
        const cartNavigationEvent = new CustomEvent('product-form:cart:navigate', {
          bubbles: true,
          cancelable: true,
          detail: {
            form: formData,
            response: responseData,
            cart: cartAfterSubmission
          }
        });

        const navigationPrevented = !this.dispatchEvent(cartNavigationEvent);
        
        if (!navigationPrevented) {
          window.location.href = `${window.Shopify.routes.root}cart`;
        }
      } catch (error) {
        this.dispatchEvent(
          new CustomEvent('product-form:submit:error', {
            bubbles: true,
            detail: {
              form: formData,
              cart: cartBeforeSubmission,
              error: error
            },
          })
        );
      } finally {
        // Re-enable submit button and stop pulsing
        this.enableSubmitButton();
      }
    }

    /**
     * Waits for a subscriber to provide cart response data after handling the cart request
     * @returns {Promise<Object>} The cart response data
     */
    waitForCartResponse() {
      return new Promise((resolve, reject) => {
        // Store the resolver for this request
        this._cartRequestResolver = { resolve, reject };
        
        // Set a timeout to prevent hanging
        const timeout = setTimeout(() => {
          if (this._cartRequestResolver) {
            delete this._cartRequestResolver;
            reject(new Error('Cart request timeout - no response received from subscriber'));
          }
        }, 30000); // 30 second timeout
        
        // Store timeout reference for cleanup
        this._cartRequestResolver.timeout = timeout;
      });
    }

    /**
     * Resolves a pending cart request with response data
     * Called by subscribers who handle the cart request
     * @param {string} requestId - The request ID from the waiting event
     * @param {Object} responseData - The cart response data
     */
    resolveCartRequest(responseData) {
      if (this._cartRequestResolver) {
        clearTimeout(this._cartRequestResolver.timeout);
        this._cartRequestResolver.resolve(responseData);
        delete this._cartRequestResolver;
      }
    }

    /**
     * Rejects a pending cart request with an error
     * Called by subscribers who handle the cart request
     * @param {string} requestId - The request ID from the waiting event
     * @param {Error} error - The error that occurred
     */
    rejectCartRequest(error) {
      if (this._cartRequestResolver) {
        clearTimeout(this._cartRequestResolver.timeout);
        this._cartRequestResolver.reject(error);
        delete this._cartRequestResolver;
      }
    }

    hasCartChanged(cartBefore, cartAfter) {
      if (!cartBefore || !cartAfter) {
        return true; // If we can't compare, assume there's a change
      }

      // Deep comparison using JSON.stringify for simplicity
      // This handles all nested changes automatically
      return JSON.stringify(cartBefore) !== JSON.stringify(cartAfter);
    }
  }

  customElements.define('product-form', ProductForm);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.product.messages"] && !Shopify.designMode) return;
  try {
    class ProductFormMessages extends HTMLElement {
    constructor() {
      super();
      
      // Pull localized error message from data attributes
      this.formId = this.dataset.formId;
      this.defaultErrorMessage = this.dataset.error;
      this.defaultSuccessMessage = this.dataset.success;
      
      // Create abort controller for event cleanup
      this.abortController = new AbortController();
    }

    connectedCallback() {
      // Cache the template content for better performance
      this.cacheTemplate();
      this.bindEvents();
    }

    disconnectedCallback() {
      // Clean up event listeners when component is removed
      this.abortController.abort();
    }

    cacheTemplate() {
      const template = this.querySelector('template');
      if (template) {
        this.template = template.innerHTML;
        this.templateElement = template;
      }
    }

    bindEvents() {
      const { signal } = this.abortController;
      
      // Listen for form submission start to clear error messages
      document.addEventListener('product-form:submit:before', this.handleSubmitStart.bind(this), { signal });
      
      // Listen for form errors
      document.addEventListener('product-form:submit:error', this.handleError.bind(this), { signal });

      // Listen for form success
      document.addEventListener('product-form:submit:success', this.handleSuccess.bind(this), { signal });
    }

    handleSubmitStart(e) {
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      this.clearMessages();
    }

    handleSuccess(e) {
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      let message = this.defaultSuccessMessage;

      const successMessageEvent = new CustomEvent('product-form:message:success', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: e.target.form,
          response: e.detail.response,
          cart: e.detail.cart,
          message: message
        }
      });

      // Dispatch the event and check if it was cancelled
      const eventCancelled = !this.dispatchEvent(successMessageEvent);

      if (eventCancelled) {
        return;
      }

      this.showMessage(successMessageEvent.detail.message);
    }

    handleError(e) { 
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      const error = e.detail.error;
      let message = this.defaultErrorMessage;
      
      // Use server response message if available (already localized)
      if (error.description) {
        message = error.description;
      } else if (error.message) {
        message = error.message;
      }

      const errorMessageEvent = new CustomEvent('product-form:message:error', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: e.target.form,
          response: e.detail.response,
          cart: e.detail.cart,
          message: message
        }
      });

      const eventCancelled = !this.dispatchEvent(errorMessageEvent);

      if (eventCancelled) {
        return;
      }

      this.showMessage(errorMessageEvent.detail.message);
    }

    showMessage(message) {
      // Clear existing error messages
      this.clearMessages();
      this.classList.remove('hide');
      
      // Use cached template content and replace <slot> with the error message
      if (this.template) {
        const messageContent = this.template.replace('<slot></slot>', message);
        
        // Insert the error message content
        this.innerHTML = messageContent;
      }
    }

    clearMessages() {
      this.classList.add('hide');

      // Restore the original template structure using cached template
      if (this.templateElement) {
        this.innerHTML = this.templateElement.outerHTML;
      }
    }
  }

  customElements.define('product-form-messages', ProductFormMessages);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["inktkenners-catalog-runtime"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('ik-catalog')) return;
  const normalize = value => String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g,'').toUpperCase();
  const variantKey = value => String(value).split('/').pop();
  const compact = value => normalize(value).replace(/[^A-Z0-9]/g,'');
  const cleanQuery = value => String(value || '').replace(/^title:\s*"(.*)"$/i,'$1').trim();
  const aliases = {BLACK:'ZWART',CYAN:'CYAAN',YELLOW:'GEEL',CARTRIDGES:'CARTRIDGE',CARTRIDGEN:'CARTRIDGE',CARTRDIGE:'CARTRIDGE',CARTRDIGES:'CARTRIDGE',CARTRIGE:'CARTRIDGE',TONERS:'TONER',INKT:'CARTRIDGE',INK:'CARTRIDGE',INKTCARTRIDGES:'CARTRIDGE',INKTCARTRIDGE:'CARTRIDGE',CANNON:'CANON',PRINTERS:'PRINTER'};
  const words = value => normalize(value).split(/[^A-Z0-9]+/).filter(Boolean).map(word=>aliases[word]||word);
  const brands=['Brother','Canon','Epson','HP','Kyocera','Lexmark','Samsung','Xerox','Lenovo','Troy'];
  const filler=new Set(['VOOR','GESCHIKT','DE','HET','EEN','VAN','MIJN','MET','EN','FOR','THE']);
  const queryContext=new Set(['CARTRIDGE','TONER','DRUM','PRINTER','NAVULINKT','NAVULFLESSEN','NAVULFLES']);
  // Join only recognised model/code prefixes. Number and suffix boundaries remain exact.
  const codedText=value=>words(value).join(' ')
    .replace(/\b(BROTHER|CANON|CANNON|EPSON|HP|KYOCERA|LEXMARK|SAMSUNG|XEROX)(?=\d)/g,'$1 ')
    .replace(/\b(MFC|DCP|HL|LC|TN|DR|TK|PGI|CLI|PG|CL|GI|TS|TR|MG|MX|MP|IP|IX|IB|MB|GX|GM|XP|WF|ET|SCX|CLX|CLP|ML|SL|QL|TD|LBP|MF|IR|FS|KM|CS|CX|MS|MC|CF|CE|CB|CC|CH|CZ|CR|PFI|BCI|G|L|T)\s+(?=(?:[A-Z]\s*)?\d)/g,'$1')
    .replace(/\b(MFC|DCP|HL)([A-Z])\s+(?=\d)/g,'$1$2')
    .replace(/(\d)\s+(XXL|XL|DW|DWF|FDW|FDN|DN|FN|CW|CDW|CDN|NWB|N|W|A|I|E)\b/g,'$1$2');
  const codeTokens=value=>(codedText(value).match(/\b[A-Z]*\d+[A-Z0-9]*\b/g)||[]);
  const codeSet=(value,family=false)=>new Set(codeTokens(value).flatMap(code=>{
    const values=[code,code.replace(/^[A-Z]+/,'')];
    if(family&&/(?:XXL|XL)$/.test(code)){const base=code.replace(/(?:XXL|XL)$/,'');values.push(base,base.replace(/^[A-Z]+/,''));}
    return values;
  }));
  const parseQuery=raw=>{
    const query=cleanQuery(raw),text=codedText(query),codes=codeTokens(query);
    const terms=words(text.replace(/\b[A-Z]*\d+[A-Z0-9]*\b/g,' ')).filter(term=>!filler.has(term)&&!(codes.length&&queryContext.has(term)));
    return {query,codes,terms,brand:brands.find(brand=>terms.includes(normalize(brand)))};
  };
  const excludedPrinters = new Set(['282610958476']);
  const printerInfo = title => {
    let normalizedTitle=String(title||'').trim().replace(/^Toner voor\s+/i,'').replace(/^Canon\s+Inktjet\s+/i,'Canon ');
    if(/^(EcoTank|WorkForce)\s/i.test(normalizedTitle))normalizedTitle='Epson '+normalizedTitle;
    if(/^LaserJet\s/i.test(normalizedTitle))normalizedTitle='HP '+normalizedTitle;
    if(/^(QL|TD)-\d/i.test(normalizedTitle))normalizedTitle='Brother '+normalizedTitle;
    const match=normalizedTitle.match(/^(Brother|Canon|Epson|HP|Kyocera|Lexmark|Samsung|Xerox|Lenovo|Troy)\s+(.+)$/i);
    if(!match) return null;
    const brand=match[1].toLowerCase()==='hp'?'HP':match[1][0].toUpperCase()+match[1].slice(1).toLowerCase();
    const patterns={Brother:/^(DCP|MFC|HL|FAX|Intellifax|P[ -]?Touch|QL|TD)(?=[ -]|\d)/i,Canon:/^(PIXMA|MAXIFY|i[ -]?SENSYS|imageCLASS|imageRUNNER|Laser Shot|LBP|MF|IR)(?=[ -]|\d)/i,Epson:/^(Expression Premium|Expression Home|Expression Photo|Expression|Workforce Pro|Workforce|EcoTank|Stylus Office|Stylus Photo|Stylus|SureColor|XP|WF|ET|L)(?=[ -]|\d)/i,HP:/^(Officejet Pro|Officejet|Deskjet Ink Advantage|Deskjet|Color Laserjet Pro MFP|Color Laserjet Pro|Color Laserjet|Laserjet Pro Ultra|Laserjet Pro MFP|Laserjet Pro|Laserjet|Photosmart|Envy Photo|Envy|Smart Tank|Designjet|Neverstop|Color Laser MFP|Color Laser|Laser MFP|Laser|Digital Copier|Fax|PageWide Managed MFP|PageWide Managed|PageWide Pro|PageWide|PSC)(?=[ -]|\d)/i,Kyocera:/^(ECOSYS|TASKalfa|FS|KM)(?=[ -]|\d)/i,Lexmark:/^(MS|MX|CS|CX|MC|MB|E|C|X|T|Z|S|Pro)(?=[ -]|\d)/i,Samsung:/^(Pro ?Xpress|Xpress|SCX|CLX|CLP|ML|SL)(?=[ -]|\d|M)/i,Xerox:/^(WorkCentre|Phaser|VersaLink|AltaLink|B|C)(?=[ -]|\d)/i,Lenovo:/^(LJ|M)(?=[ -]|\d)/i,Troy:/^(\d+)\s+Micr/i};
    const series=match[2].match(patterns[brand]);
    if(!series || !/\d/.test(match[2])) return null;
    const label=brand==='Troy'?'MICR':series[1].toLowerCase().replace(/\b[a-z]/g,letter=>letter.toUpperCase()).replace(/\b(dcp|mfc|hl|fax|ql|td|lbp|mf|ir|xp|wf|et|fs|km|ml|sl|scx|clx|clp|cs|cx|ms|mx|mc|mb|lj|l|m|psc|mfp)\b/gi,value=>value.toUpperCase()).replace(/Pro ?Xpress/i,'ProXpress').replace(/Ecotank/i,'EcoTank').replace(/Workforce/i,'WorkForce').replace(/Officejet/i,'OfficeJet').replace(/Deskjet/i,'DeskJet').replace(/Laserjet/i,'LaserJet');
    return {brand,series:label};
  };
  const ownURL = value => {const url=new URL(value,location.origin);if(url.origin!==location.origin)throw new Error('foreign_url');return url;};
  const cache=new Map();
  const getData=async url=>{
    const controller=new AbortController();const timeout=setTimeout(()=>controller.abort(),15000);
    try{const response=await fetch(url,{credentials:'same-origin',signal:controller.signal,headers:{Accept:'text/html'}});if(!response.ok)throw new Error('unavailable');const data=await response.json();if(data.version!==1)throw new Error('invalid_data');return data;}finally{clearTimeout(timeout);}
  };
  const loadPages=async(path,kind,initial,sort)=>{
    const base=ownURL(path);base.searchParams.delete('page');base.searchParams.set('view','ik-data');if(sort)base.searchParams.set('sort_by',sort);
    const key=base.href;
    if(cache.has(key))return cache.get(key);
    const promise=(async()=>{
      const first=initial&&initial.page===1&&initial.pages===1?initial:await getData(base.href);
      if(!Array.isArray(first[kind])||first.pages>100)throw new Error('invalid_catalog');
      const batches=[first[kind]];let next=2;
      await Promise.all(Array.from({length:Math.min(3,Math.max(0,first.pages-1))},async()=>{while(next<=first.pages){const page=next++;const url=new URL(base);url.searchParams.set('page',page);const result=await getData(url.href);if(result.page!==page||result.total!==first.total||!Array.isArray(result[kind]))throw new Error('incomplete');batches[page-1]=result[kind];}}));
      const result=batches.flat();if(result.length!==first.total||new Set(result.map(item=>String(item.id))).size!==result.length)throw new Error('incomplete');return result;
    })();cache.set(key,promise);promise.catch(()=>cache.delete(key));return promise;
  };
  const memberships=product=>{
    const aliases=product.printer_aliases||{},resolve=id=>variantKey(aliases[String(id)]||id);
    const allowed=new Map((product.printer_selections||[]).filter(item=>Array.isArray(item.allowed_variant_ids)).map(item=>[resolve(item.id),new Set(item.allowed_variant_ids.map(variantKey))]));
    const result=new Map();
    for(const [index,id]of(product.collections||[]).entries()){
      const key=resolve(id);if(excludedPrinters.has(key))continue;
      result.set(key,{id:key,title:product.collection_titles?.[index]||'',url:product.collection_urls?.[index]||'',allowed:allowed.get(key)});
    }
    for(const item of product.pending_printers||[]){const key=resolve(item.id);if(!excludedPrinters.has(key)&&!result.has(key))result.set(key,{id:key,title:item.title,url:item.url,allowed:allowed.get(key)});}
    return [...result.values()];
  };
  const rowCache=new WeakMap(),printerCache=new WeakMap();
  const productRows=products=>{
    if(rowCache.has(products))return rowCache.get(products);
    const rows=products.flatMap((product,position)=>{
    const colorIndex=(product.options||[]).findIndex(option=>/^(kleur|colou?r)$/i.test(option));
    const tags=product.tags||[];
    const brand=brands.find(value=>normalize(value)===normalize(product.type))||brands.find(value=>tags.some(tag=>normalize(tag)===normalize(value)))||brands.find(value=>words(product.title).includes(normalize(value)))||product.type;
    const types=tags.filter(tag=>/^(toner|inktcartridge|drum|papier|labels?|etiketten)$/i.test(tag));
    const titleCodes=codeSet(product.title,true),allMemberships=memberships(product).map(item=>({...item,codes:codeSet(item.title),wordSet:new Set(words(item.title))}));
    return (product.variants||[]).map(variant=>{
      const printers=allMemberships.filter(item=>!item.allowed||item.allowed.has(variantKey(variant.id)));
      const collections=printers.map(item=>item.id),collection_titles=printers.map(item=>item.title),collection_urls=printers.map(item=>item.url);
      const printerCodes=codeSet(collection_titles.join(' '));
      const productWords=words([product.title,product.type,product.vendor,...tags,variant.title].join(' '));
      const printerSearch=printers;
      return {product,variant,position,brand,types,collections,collection_titles,collection_urls,printers,printerSearch,productWordSet:new Set(productWords),color:colorIndex>=0?variant.options?.[colorIndex]:(variant.title==='Default Title'?'':variant.title),titleCodes,printerCodes,allCodes:new Set([...titleCodes,...printerCodes]),wordSet:new Set([...productWords,...words(collection_titles.join(' '))])};
    });
    });
    rowCache.set(products,rows);return rows;
  };
  const matchesTerms=(wordSet,terms)=>terms.every(term=>wordSet.has(term)||[...wordSet].some(word=>!/[0-9]/.test(term)&&term.length>=3&&word.startsWith(term)));
  const searchRows=(rows,raw)=>{
    const parsed=parseQuery(raw),{query,codes,terms,brand}=parsed;if(!query)return rows;
    const key=compact(query);const exact=rows.filter(row=>[row.variant.sku,row.variant.barcode].some(value=>value&&compact(value)===key));if(exact.length)return exact;
    if(/^\d{8,}$/.test(key))return [];
    return rows.filter(row=>{
      if(brand&&normalize(row.brand)!==normalize(brand))return false;
      if(!codes.length)return matchesTerms(row.wordSet,terms);
      if(codes.every(code=>row.titleCodes.has(code))&&matchesTerms(row.productWordSet,terms))return true;
      return row.printerSearch.some(printer=>codes.every(code=>printer.codes.has(code))&&terms.every(term=>matchesTerms(row.productWordSet,[term])||matchesTerms(printer.wordSet,[term])));
    }).sort((a,b)=>codes.filter(code=>b.titleCodes.has(code)).length-codes.filter(code=>a.titleCodes.has(code)).length||Number(b.variant.available)-Number(a.variant.available)||a.position-b.position);
  };
  const printerMatches=(products,raw)=>{
    const {query,codes,terms,brand}=parseQuery(raw);if(compact(query).length<2||/^\d{8,}$/.test(compact(query)))return [];
    if(!printerCache.has(products)){
      const inventory=new Map();
      for(const product of products)for(const item of memberships(product)){
        const info=printerInfo(item.title);
        if(!item.url||!info||item.allowed&&!(product.variants||[]).some(variant=>item.allowed.has(variantKey(variant.id))))continue;
        if(!inventory.has(item.id))inventory.set(item.id,{id:item.id,title:item.title,url:item.url,brand:info.brand,codes:codeSet(item.title),wordSet:new Set(words(item.title))});
      }
      printerCache.set(products,[...inventory.values()]);
    }
    return printerCache.get(products).filter(item=>(!brand||normalize(item.brand)===normalize(brand))&&codes.every(code=>item.codes.has(code))&&matchesTerms(item.wordSet,terms)).map(item=>({id:item.id,title:item.title,url:item.url,exact:codes.length>0})).sort((a,b)=>Number(b.exact)-Number(a.exact)||a.title.localeCompare(b.title,undefined,{numeric:true}));
  };
  const backordered=variant=>variant?.backorder_enabled===true&&variant.available===true&&variant.inventory_tracked===true&&variant.inventory_policy==='continue'&&Number.isFinite(variant.inventory_quantity)&&variant.inventory_quantity<=0;
  const physicallyAvailable=variant=>variant.available&&(!variant.backorder_enabled||!variant.inventory_tracked||variant.in_stock===true);
  const searchLoads=new Map();
  const searchCacheKey=root=>{
    if(typeof document==='undefined')return null;
    const scope=document.querySelector('inktkenners-search[data-ik-search-cache-key]')?.dataset.ikSearchCacheKey;
    return scope?'ik_search_v3:'+scope+':'+root+':'+(document.documentElement.lang||''):null;
  };
  const validSearchCache=value=>value?.version===3&&Number.isFinite(value.created)&&Date.now()-value.created>=0&&Date.now()-value.created<90000&&Array.isArray(value.products)&&value.products.every(product=>product&&Array.isArray(product.variants)&&product.variants.every(variant=>typeof variant.inventory_tracked==='boolean'&&typeof variant.backorder_enabled==='boolean')&&Array.isArray(product.printer_selections));
  const loadSearch=(raw,root,seed)=>{
    const storageKey=searchCacheKey(root),key=storageKey||root;
    if(searchLoads.has(key))return searchLoads.get(key);
    const promise=(async()=>{
      if(storageKey)try{
        const stored=sessionStorage.getItem(storageKey);
        if(stored){let saved;try{saved=JSON.parse(stored);}catch{}if(validSearchCache(saved))return saved.products;sessionStorage.removeItem(storageKey);}
      }catch{}
      const products=await loadPages(root+'collections/all','products');
      if(storageKey)try{const saved={version:3,created:Date.now(),products};if(validSearchCache(saved))sessionStorage.setItem(storageKey,JSON.stringify(saved));}catch{}
      return products;
    })();
    searchLoads.set(key,promise);promise.catch(()=>searchLoads.delete(key));return promise;
  };
  const node=(tag,className,text)=>{const element=document.createElement(tag);if(className)element.className=className;if(text!==undefined)element.textContent=text;return element;};
  class Catalog extends HTMLElement{
    static loadCollection=(path,initial,sort)=>loadPages(path,'products',initial,sort);
    static loadPrinters=root=>loadPages(root+'collections','collections').then(items=>items.filter(item=>item.printer?.primary&&!excludedPrinters.has(String(item.id))).map(item=>({...item,...item.printer})));
    static matchPrinters=(items,raw)=>{const {query,codes,terms,brand}=parseQuery(raw);if(compact(query).length<2)return [];return items.filter(item=>(!brand||normalize(printerInfo(item.title)?.brand)===normalize(brand))&&codes.every(code=>codeSet(item.title).has(code))&&matchesTerms(new Set(words(item.title)),terms)).sort((a,b)=>a.title.localeCompare(b.title,undefined,{numeric:true}));};
    static loadSearch=loadSearch;
    static searchRows=searchRows;
    static productRows=productRows;
    static printerMatches=printerMatches;
    static backordered=backordered;
    static printerInfo=printerInfo;
    connectedCallback(){
      if(this.started)return;this.started=true;this.events=new AbortController();const signal=this.events.signal;
      this.labels=JSON.parse(this.querySelector('[data-catalog-labels]').textContent);this.seed=JSON.parse(this.querySelector('[data-catalog-data]').textContent);this.grid=this.querySelector('[data-catalog-grid]');this.message=this.querySelector('[data-catalog-message]');this.counter=this.querySelector('[data-catalog-count]');this.sort=this.querySelector('[data-catalog-sort]');this.limit=28;this.choices={brand:[],type:[],color:[],printer:[]};this.readState();
      if(this.dataset.mode==='search'){const wrapper=this.closest('[data-ik-search-page]');if(wrapper&&!wrapper.dataset.query&&this.query){wrapper.querySelector('h1').textContent=this.text('search_heading')+': '+this.query;for(const input of wrapper.querySelectorAll('input[name="q"]'))input.value=this.query;}}
      this.querySelector('.ik-catalog__controls').hidden=false;this.querySelector('.ik-catalog__toolbar').hidden=false;
      this.querySelector('.ik-catalog__filters').open=matchMedia('(min-width:768px)').matches;
      this.addEventListener('change',event=>this.change(event),{signal});
      this.querySelector('[data-printer-query]').addEventListener('input',()=>this.drawFacet('printer'),{signal});
      this.querySelector('[data-catalog-more]').addEventListener('click',()=>{this.limit+=28;this.drawCards();},{signal});
      this.querySelector('[data-catalog-view]').addEventListener('click',event=>{const button=event.currentTarget;const list=button.getAttribute('aria-pressed')!=='true';button.setAttribute('aria-pressed',String(list));this.grid.classList.toggle('is-list',list);},{signal});
      this.querySelector('[data-catalog-active]').addEventListener('click',event=>{const button=event.target.closest('button');if(!button)return;if(button.dataset.clear==='all'){for(const name of Object.keys(this.state))this.state[name]=[];this.min='';this.max='';this.available=false;}else this.state[button.dataset.group]=this.state[button.dataset.group].filter(value=>value!==button.dataset.value);this.syncInputs();this.commit();},{signal});
      addEventListener('popstate',()=>{this.readState();if(this.rows){this.syncInputs();this.apply();}},{signal});
      this.load();
    }
    disconnectedCallback(){this.events?.abort();this.started=false;}
    text(key,values={}){let result=this.labels[key]||key;for(const [name,value]of Object.entries(values))result=result.replaceAll('{'+name+'}',value);return result;}
    readState(){
      const params=new URL(location.href).searchParams;this.state={};for(const name of ['brand','type','color','printer'])this.state[name]=params.getAll('ik_'+name);
      for(const [key,value]of params){if(key.startsWith('uff_')){if(key.endsWith('_collections'))this.state.printer.push(...value.split(','));if(/option.*kleur|_color$/i.test(key))this.state.color.push(...value.split(','));if(key.endsWith('_tags'))this.state.type.push(...value.split(','));}}
      this.state.printer=this.state.printer.map(id=>this.printerAliases?.[id]||id);this.min=params.get('ik_min')||'';this.max=params.get('ik_max')||'';this.available=params.get('ik_available')==='1';this.order=params.get('ik_sort')||({'r':'manual','price':'price-ascending','-price':'price-descending','title':'title-ascending','-title':'title-descending'}[params.get('usf_sort')]||params.get('sort_by'))||'manual';this.query=this.dataset.mode==='search'?cleanQuery(params.get('q')||''):'';this.limit=28;
    }
    syncInputs(){this.sort.value=this.order;this.querySelector('[data-min-price]').value=this.min;this.querySelector('[data-max-price]').value=this.max;this.querySelector('[data-available]').checked=this.available;}
    async load(){
      this.setAttribute('aria-busy','true');this.counter.textContent=this.text('loading');
      try{const sort=this.order==='best-selling'?'best-selling':new URL(location.href).searchParams.get('sort_by')||undefined;const initial=this.dataset.mode==='collection'&&this.seed.page===1&&this.order!=='best-selling'?this.seed:null;const products=this.dataset.mode==='search'?await Catalog.loadSearch(new URL(location.href).searchParams.get('q')||'',this.dataset.root,this.seed):await Catalog.loadCollection(this.dataset.url,initial,sort);if(!this.isConnected)return;this.printerAliases=Object.assign({},...products.map(product=>product.printer_aliases||{}));this.state.printer=this.state.printer.map(id=>this.printerAliases[id]||id);const allowedVariants=Array.isArray(this.seed.allowed_variant_ids)?new Set(this.seed.allowed_variant_ids.map(variantKey)):null;this.rows=productRows(products).filter(row=>allowedVariants===null||allowedVariants.has(variantKey(row.variant.id)));if(sort==='best-selling')this.bestOrder=new Map(products.map((product,index)=>[product.id,index]));this.buildChoices();this.syncInputs();this.querySelector('[data-filter-fields]').disabled=false;this.sort.disabled=false;this.querySelector('[data-catalog-pagination]').hidden=true;this.dataset.ready='true';this.apply();}
      catch{this.counter.textContent='';this.message.textContent=this.text('load_error');this.message.hidden=false;this.querySelector('.ik-catalog__controls').hidden=true;}
      finally{this.removeAttribute('aria-busy');}
    }
    buildChoices(){
      this.collectionMap=new Map();const groups={brand:new Set(),type:new Set(),color:new Set()};
      for(const row of searchRows(this.rows,this.query)){if(row.brand)groups.brand.add(row.brand);row.types.forEach(value=>groups.type.add(value));if(row.color)groups.color.add(row.color);row.collections.forEach((id,index)=>this.collectionMap.set(String(id),{label:row.collection_titles[index],url:row.collection_urls[index]}));}
      for(const name of Object.keys(groups))this.choices[name]=[...groups[name]].map(value=>({value,label:value})).sort((a,b)=>a.label.localeCompare(b.label,this.dataset.locale,{numeric:true}));
      this.choices.printer=[...this.collectionMap].filter(([id,item])=>!excludedPrinters.has(id)).map(([value,item])=>({value,label:item.label})).sort((a,b)=>a.label.localeCompare(b.label,this.dataset.locale,{numeric:true}));
    }
    matches(row,except){
      if(except!=='brand'&&this.state.brand.length&&!this.state.brand.includes(row.brand))return false;
      if(except!=='type'&&this.state.type.length&&!this.state.type.some(value=>row.types.includes(value)))return false;
      if(except!=='color'&&this.state.color.length&&!this.state.color.includes(row.color))return false;
      if(except!=='printer'&&this.state.printer.length&&!this.state.printer.some(value=>row.collections.includes(String(value))))return false;
      if(this.available&&!physicallyAvailable(row.variant))return false;
      if(this.min!==''&&row.variant.price<Math.round(Number(this.min)*100))return false;
      if(this.max!==''&&row.variant.price>Math.round(Number(this.max)*100))return false;return true;
    }
    drawFacet(name){
      const parent=this.querySelector('[data-facet-options="'+name+'"]');const facet=this.querySelector('[data-facet="'+name+'"]');const options=this.choices[name];facet.hidden=!options.length;
      if(!options.length)return;const candidates=this.baseRows.filter(row=>this.matches(row,name));const counts=new Map();
      for(const row of candidates){const values=name==='printer'?row.collections:name==='type'?row.types:[row[name]];for(const value of values)counts.set(value,(counts.get(value)||0)+1);}
      const query=name==='printer'?compact(this.querySelector('[data-printer-query]').value):'';const visible=options.filter(option=>!query||compact(option.label).includes(query));
      const fragment=document.createDocumentFragment();for(const option of visible.slice(0,name==='printer'?80:100)){const label=node('label','ik-facet__option');const input=node('input');input.type='checkbox';input.dataset.facet=name;input.value=option.value;input.checked=this.state[name].includes(option.value);input.disabled=!input.checked&&!counts.get(option.value);label.append(input,document.createTextNode(option.label),node('span','',String(counts.get(option.value)||0)));fragment.append(label);}
      if(visible.length>80&&name==='printer')fragment.append(node('p','',this.text('refine_printer')));if(!visible.length)fragment.append(node('p','',this.text('no_printer')));parent.replaceChildren(fragment);
    }
    apply(){
      const focused=document.activeElement;const focusedFacet=this.contains(focused)&&focused?.matches('input[data-facet]')?{name:focused.dataset.facet,value:focused.value}:null;const focusedChip=this.contains(focused)&&focused?.closest('[data-catalog-active]');
      this.baseRows=searchRows(this.rows,this.query);this.filtered=this.baseRows.filter(row=>this.matches(row));
      const order=this.order;const compare=order==='price-ascending'?(a,b)=>a.variant.price-b.variant.price:order==='price-descending'?(a,b)=>b.variant.price-a.variant.price:order==='title-ascending'?(a,b)=>(a.product.title+' '+a.variant.title).localeCompare(b.product.title+' '+b.variant.title,this.dataset.locale,{numeric:true}):order==='title-descending'?(a,b)=>(b.product.title+' '+b.variant.title).localeCompare(a.product.title+' '+a.variant.title,this.dataset.locale,{numeric:true}):order==='created-descending'?(a,b)=>Number(b.product.created)-Number(a.product.created):order==='best-selling'&&this.bestOrder?(a,b)=>(this.bestOrder.get(a.product.id)??Infinity)-(this.bestOrder.get(b.product.id)??Infinity):null;
      if(compare)this.filtered.sort(compare);for(const name of Object.keys(this.choices))this.drawFacet(name);this.drawChips();this.drawCards();
      if(focusedFacet){const replacement=[...this.querySelectorAll('input[data-facet]')].find(input=>input.dataset.facet===focusedFacet.name&&input.value===focusedFacet.value);replacement?.focus({preventScroll:true});}else if(focusedChip){(this.querySelector('[data-catalog-active] button')||this.sort).focus({preventScroll:true});}
    }
    drawChips(){
      const parent=this.querySelector('[data-catalog-active]');parent.replaceChildren();let count=0;
      for(const [group,values]of Object.entries(this.state))for(const value of values){const text=group==='printer'?(this.collectionMap.get(value)?.label||value):value;const button=node('button','',text+' ×');button.type='button';button.dataset.group=group;button.dataset.value=value;button.setAttribute('aria-label',this.text('remove')+' '+text);parent.append(button);count++;}
      if(count||this.min!==''||this.max!==''||this.available){const clear=node('button','',this.text('clear'));clear.type='button';clear.dataset.clear='all';parent.append(clear);parent.hidden=false;}else parent.hidden=true;
    }
    drawCards(){
      const visible=this.filtered.slice(0,this.limit);const money=new Intl.NumberFormat(this.dataset.locale,{style:'currency',currency:this.dataset.currency});const fragment=document.createDocumentFragment();
      for(const [index,row] of visible.entries()){const product=row.product,variant=row.variant;const card=node('article','ik-card');card.dataset.variantId=variant.id;const href=ownURL(product.url);href.searchParams.set('variant',variant.id);const imageLink=node('a','ik-card__image');imageLink.href=href.pathname+href.search;imageLink.tabIndex=-1;imageLink.setAttribute('aria-hidden','true');
        if(variant.image){const image=node('img');image.alt='';image.loading=index<3?'eager':'lazy';image.width=480;image.height=480;image.sizes='(max-width: 767px) 46vw, 250px';image.srcset=[240,360,480].map(width=>{const url=new URL(variant.image,location.origin);url.searchParams.set('width',width);return url.href+' '+width+'w';}).join(',');image.src=variant.image;imageLink.append(image);}card.append(imageLink);const body=node('div','ik-card__body');body.append(node('p','ik-card__vendor',product.vendor));const heading=node('h2','ik-card__title');const title=node('a','',product.title);title.href=imageLink.href;heading.append(title);body.append(heading);if(variant.title!=='Default Title')body.append(node('p','ik-card__variant',variant.title));const price=node('p','ik-card__price');price.append(node('strong','',money.format(variant.price/100)));if(variant.compare>variant.price)price.append(node('s','',money.format(variant.compare/100)));body.append(price);if(!variant.available)body.append(node('p','ik-card__unavailable',this.text('sold_out')));else if(backordered(variant))body.append(node('p','ik-card__delivery',this.text('backorder')));const link=node('a','ik-card__link',this.text('view_product')+' →');link.href=imageLink.href;link.setAttribute('aria-label',product.title+' – '+variant.title);body.append(link);card.append(body);fragment.append(card);}
      this.grid.replaceChildren(fragment);this.counter.textContent=this.filtered.length===1?this.text('count_one'):this.text('count',{count:this.filtered.length});this.message.hidden=this.filtered.length>0;this.message.textContent=this.text('no_results');this.querySelector('[data-catalog-progress]').textContent=this.text('progress',{shown:visible.length,total:this.filtered.length});this.querySelector('[data-catalog-more-wrap]').hidden=!this.filtered.length;this.querySelector('[data-catalog-more]').hidden=visible.length>=this.filtered.length;
    }
    async change(event){
      const input=event.target;if(input.dataset.facet){const group=input.dataset.facet;this.state[group]=input.checked?[...new Set([...this.state[group],input.value])]:this.state[group].filter(value=>value!==input.value);}
      else if(input.matches('[data-min-price]'))this.min=input.value;
      else if(input.matches('[data-max-price]'))this.max=input.value;
      else if(input.matches('[data-available]'))this.available=input.checked;
      else if(input.matches('[data-catalog-sort]')){this.order=input.value;if(this.order==='best-selling'&&!this.bestOrder){this.sort.disabled=true;try{const products=await Catalog.loadCollection(this.dataset.url,null,'best-selling');this.bestOrder=new Map(products.map((product,index)=>[product.id,index]));}catch{this.order='manual';this.sort.value='manual';}this.sort.disabled=false;}}
      else return;this.commit();
    }
    commit(){const url=new URL(location.href);for(const key of [...url.searchParams.keys()])if(key.startsWith('ik_')||key.startsWith('uff_')||['usf_sort','sort_by','page'].includes(key))url.searchParams.delete(key);for(const [name,values]of Object.entries(this.state))for(const value of values)url.searchParams.append('ik_'+name,value);if(this.min!=='')url.searchParams.set('ik_min',this.min);if(this.max!=='')url.searchParams.set('ik_max',this.max);if(this.available)url.searchParams.set('ik_available','1');if(this.order!=='manual')url.searchParams.set('ik_sort',this.order);history.pushState({},'',url);this.limit=28;this.apply();}
  }
  class PrinterFinder extends HTMLElement{
    connectedCallback(){
      if(this.started)return;
      this.started=true;
      this.epoch=(this.epoch||0)+1;
      this.searchSerial=(this.searchSerial||0)+1;
      this.labels=JSON.parse(this.querySelector('[data-finder-labels]').textContent);
      this.brand=this.querySelector('[data-printer-brand]');
      this.series=this.querySelector('[data-printer-series]');
      this.model=this.querySelector('[data-printer-model]');
      this.button=this.querySelector('button');
      this.status=this.querySelector('[data-finder-status]');
      this.direct=this.querySelector('[data-printer-direct]');
      this.matches=this.querySelector('[data-printer-matches]');
      this.directStatus=this.querySelector('[data-printer-direct-status]');
      this.events=new AbortController();
      const signal=this.events.signal;
      if(this.direct&&this.matches){
        if(!this.matches.id){
          PrinterFinder.resultId=(PrinterFinder.resultId||0)+1;
          this.matches.id='ik-printer-finder-results-'+PrinterFinder.resultId;
        }
        this.direct.setAttribute('role','combobox');
        this.direct.setAttribute('aria-autocomplete','list');
        this.direct.setAttribute('aria-haspopup','listbox');
        this.direct.setAttribute('aria-controls',this.matches.id);
        this.matches.setAttribute('role','listbox');
        this.clearMatches();
        this.direct.addEventListener('keydown',event=>this.onResultKey(event),{signal});
        this.matches.addEventListener('keydown',event=>{
          if(event.key==='Escape')this.onResultKey(event);
        },{signal});
      }
      this.direct?.addEventListener('input',()=>{
        clearTimeout(this.searchTimer);
        this.searchSerial++;
        this.clearMatches();
        this.searchTimer=setTimeout(()=>this.searchModels(),150);
      },{signal});
      this.brand.addEventListener('change',()=>this.chooseBrand(),{signal});
      this.series.addEventListener('change',()=>this.chooseSeries(),{signal});
      this.model.addEventListener('change',()=>{
        this.button.disabled=!this.selectedModel();
        this.saveSelection();
      },{signal});
      this.querySelector('form').addEventListener('submit',event=>{
        event.preventDefault();
        const selected=this.selectedModel();
        if(selected&&!this.button.disabled){
          this.saveSelection();
          location.assign(ownURL(selected.url).href);
        }
      },{signal});
      window.addEventListener('popstate',()=>this.restoreSelection(),{signal});
      window.addEventListener('pageshow',event=>{if(event.persisted)this.restoreSelection();},{signal});
      this.restoreSelection();
    }
    disconnectedCallback(){
      this.events?.abort();
      clearTimeout(this.searchTimer);
      this.epoch=(this.epoch||0)+1;
      this.searchSerial=(this.searchSerial||0)+1;
      this.pendingCatalog=null;
      this.models=null;
      this.started=false;
    }
    current(epoch){return this.started&&this.isConnected&&this.epoch===epoch;}
    plainState(value){
      if(value===null)return true;
      if(typeof value!=='object')return false;
      const prototype=Object.getPrototypeOf(value);
      return prototype===Object.prototype||prototype===null;
    }
    selection(){return {brand:this.brand.value,series:this.series.value,model:this.model.value};}
    historySelection(){
      try{
        const state=history.state;
        if(!this.plainState(state)||!state)return null;
        const saved=state.__inktkennersPrinterFinderV1;
        if(!saved||typeof saved!=='object'||saved.root!==this.dataset.root)return null;
        if(!['brand','series','model'].every(key=>typeof saved[key]==='string'))return null;
        return {brand:saved.brand,series:saved.series,model:saved.model};
      }catch{return null;}
    }
    saveSelection(){
      if(!this.started||!this.isConnected)return;
      try{
        const state=history.state;
        // Preserve foreign primitives, arrays, Dates, Maps and other non-plain
        // state verbatim: this enhancement must not replace their representation.
        if(!this.plainState(state))return;
        history.replaceState({...state,__inktkennersPrinterFinderV1:{root:this.dataset.root,...this.selection()}},'',location.href);
      }catch{ /* History may be unavailable or rate-limited; navigation still works. */ }
    }
    catalogKey(){
      const url=ownURL(this.dataset.root+'collections');
      url.searchParams.delete('page');
      url.searchParams.set('view','ik-data');
      return url.href;
    }
    requestCatalog(fresh=false){
      // Only coalesce a traversal with an already pending traversal refresh.
      // A pre-traversal cached/ordinary load is not fresh validation.
      if(this.pendingCatalog&&(!fresh||this.pendingCatalog.fresh))return this.pendingCatalog.promise;
      if(!fresh&&this.models)return Promise.resolve(this.models);
      cache.delete(this.catalogKey());
      const ticket={fresh,promise:null};
      ticket.promise=Catalog.loadPrinters(this.dataset.root).finally(()=>{
        if(this.pendingCatalog===ticket)this.pendingCatalog=null;
      });
      this.pendingCatalog=ticket;
      return ticket.promise;
    }
    fill(select,items,label){
      select.replaceChildren(new Option(label,''),...items.map(item=>new Option(item.label,item.value)));
      select.disabled=!items.length;
    }
    clearMatches(){
      this.activeResult=-1;
      this.direct?.setAttribute('aria-expanded','false');
      this.direct?.removeAttribute('aria-activedescendant');
      this.matches?.replaceChildren();
      if(this.matches)this.matches.hidden=true;
      if(this.directStatus)this.directStatus.textContent='';
    }
    resultLinks(){
      return this.matches&&!this.matches.hidden?[...this.matches.querySelectorAll('a[role="option"]')]:[];
    }
    selectResult(index){
      const links=this.resultLinks();
      if(!links.length)return;
      this.activeResult=(index+links.length)%links.length;
      links.forEach((link,i)=>{
        const active=i===this.activeResult;
        link.setAttribute('aria-selected',String(active));
        link.style.outline=active?'2px solid currentColor':'';
      });
      const active=links[this.activeResult];
      this.direct.setAttribute('aria-activedescendant',active.id);
      active.scrollIntoView({block:'nearest'});
    }
    onResultKey(event){
      if(event.isComposing)return;
      if(event.key==='Escape'){
        event.preventDefault();
        clearTimeout(this.searchTimer);
        this.searchSerial++;
        this.clearMatches();
        this.direct?.focus();
        return;
      }
      const links=this.resultLinks();
      if(!links.length)return;
      if(event.key==='ArrowDown'||event.key==='ArrowUp'){
        event.preventDefault();
        const start=this.activeResult<0?(event.key==='ArrowDown'?0:links.length-1):this.activeResult+(event.key==='ArrowDown'?1:-1);
        this.selectResult(start);
      }else if(event.key==='Enter'&&this.activeResult>=0&&links[this.activeResult]){
        event.preventDefault();
        location.assign(ownURL(links[this.activeResult].href).href);
      }
      // Tab and Shift-Tab are deliberately untouched: real links keep their
      // native focus order, click behavior and Enter activation.
    }
    clearDependent(){
      this.button.disabled=true;
      this.fill(this.series,[],this.labels.choose_series);
      this.fill(this.model,[],this.labels.choose_model);
    }
    selectedModel(){
      if(!this.models||this.model.disabled||this.series.disabled||!this.model.value)return null;
      return this.models.find(item=>String(item.id)===this.model.value&&item.brand===this.brand.value&&item.series===this.series.value)||null;
    }
    renderSelection(target,models){
      this.models=models;
      const brand=target?.brand||'';
      this.brand.value=[...this.brand.options].some(option=>option.value===brand)?brand:'';
      const series=[...new Set(models.filter(item=>item.brand===this.brand.value).map(item=>item.series))].sort((a,b)=>a.localeCompare(b));
      this.fill(this.series,series.map(value=>({value,label:value})),this.labels.choose_series);
      this.series.value=series.includes(target?.series)?target.series:'';
      const choices=models.filter(item=>item.brand===this.brand.value&&item.series===this.series.value).sort((a,b)=>a.title.localeCompare(b.title,this.dataset.locale,{numeric:true}));
      this.fill(this.model,choices.map(item=>({value:String(item.id),label:item.title})),this.labels.choose_model);
      this.model.value=choices.some(item=>String(item.id)===target?.model)?target.model:'';
      this.button.disabled=!this.selectedModel();
      this.status.textContent=this.brand.value&&!series.length?this.labels.no_models:'';
    }
    async restoreSelection(){
      const epoch=++this.epoch;
      this.searchSerial++;
      clearTimeout(this.searchTimer);
      this.clearMatches();
      const target=this.historySelection();
      // Always invalidate the old local AND shared snapshot, including empty
      // history entries and reattachment. Never persist from an async restore.
      this.models=null;
      this.clearDependent();
      this.brand.value='';
      this.status.textContent='';
      if(!target?.brand){
        cache.delete(this.catalogKey());
        // A later explicit load may not adopt an old pending ordinary request;
        // an already-fresh traversal refresh stays coalescable.
        if(this.pendingCatalog&&!this.pendingCatalog.fresh)this.pendingCatalog=null;
        return;
      }
      this.brand.value=target.brand;
      if(!this.brand.value){cache.delete(this.catalogKey());if(this.pendingCatalog&&!this.pendingCatalog.fresh)this.pendingCatalog=null;return;}
      this.status.textContent=this.labels.loading;
      try{
        const models=await this.requestCatalog(true);
        if(!this.current(epoch))return;
        this.renderSelection(target,models);
      }catch{
        if(!this.current(epoch))return;
        this.models=null;
        this.clearDependent();
        this.status.textContent=this.labels.error;
      }
    }
    async chooseBrand(){
      const epoch=++this.epoch;
      this.searchSerial++;
      clearTimeout(this.searchTimer);
      this.clearMatches();
      const brand=this.brand.value;
      this.clearDependent();
      this.status.textContent='';
      this.saveSelection();
      if(!brand)return;
      this.status.textContent=this.labels.loading;
      try{
        const models=await this.requestCatalog();
        if(!this.current(epoch)||this.brand.value!==brand)return;
        this.renderSelection({brand,series:'',model:''},models);
      }catch{
        if(this.current(epoch)&&this.brand.value===brand)this.status.textContent=this.labels.error;
      }
    }
    chooseSeries(){
      if(!this.models||this.series.disabled)return;
      const target={brand:this.brand.value,series:this.series.value,model:''};
      this.renderSelection(target,this.models);
      this.saveSelection();
    }
    async searchModels(){
      if(!this.direct||!this.matches)return;
      const epoch=this.epoch;
      const serial=++this.searchSerial;
      const query=this.direct.value.trim();
      this.clearMatches();
      if(compact(query).length<2)return;
      this.directStatus.textContent=this.labels.loading;
      try{
        // Search shares a validated snapshot but never silently replaces the
        // cascading selection's model list. Traversal explicitly invalidates it.
        const models=await this.requestCatalog();
        if(!this.current(epoch)||serial!==this.searchSerial||this.direct.value.trim()!==query)return;
        if(!this.models)this.renderSelection(this.selection(),models);
        const results=Catalog.matchPrinters(models,query).slice(0,12);
        const fragment=document.createDocumentFragment();
        for(const [index,item] of results.entries()){
          const li=node('li');const link=node('a','',item.title);
          li.setAttribute('role','presentation');
          link.id=this.matches.id+'-option-'+index;
          link.setAttribute('role','option');
          link.setAttribute('aria-selected','false');
          link.href=ownURL(item.url).href;li.append(link);fragment.append(li);
        }
        this.matches.replaceChildren(fragment);
        this.matches.hidden=!results.length;
        this.direct.setAttribute('aria-expanded',String(results.length>0));
        this.directStatus.textContent=results.length?this.labels.results:this.labels.no_match;
      }catch{
        if(this.current(epoch)&&serial===this.searchSerial&&this.direct.value.trim()===query)this.directStatus.textContent=this.labels.error;
      }
    }
  }
  customElements.define('ik-catalog',Catalog);customElements.define('ik-printer-finder',PrinterFinder);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["inktkenners-product-delivery"] && !Shopify.designMode) return;
  try {
    (() => {
  if(customElements.get('ik-product-delivery'))return;
  const backordered=(variant,quantity,items=[])=>{
    if(!variant?.available||!variant.inventory_management||variant.inventory_policy!=='continue')return false;
    const stock=Number(variant.inventory_quantity);if(!Number.isFinite(stock))return false;
    const existing=items.filter(item=>String(item.variant_id??item.id)===String(variant.id)).reduce((total,item)=>total+Math.max(0,Number(item.quantity)||0),0);
    return Math.max(1,Math.floor(Number(quantity)||1))+existing>Math.max(0,stock);
  };
  class ProductDelivery extends HTMLElement{
    static backordered=backordered;
    connectedCallback(){
      if(this.ready)return;this.ready=true;
      this.data=JSON.parse(this.querySelector('[data-ik-delivery-data]').textContent);this.form=this.closest('form');
      if(!this.form)return;
      this.scope=this.closest('.product--outer')||this.form;this.selection=this.form.querySelector('[data-variant-selection]');this.cartItems=window.InktkennersBackorder?.cart?.items||this.data.cart;
      this.events=new AbortController();const signal=this.events.signal;
      for(const name of ['change','input','variant-change','variant:change'])this.form.addEventListener(name,()=>this.schedule(),{signal});
      document.addEventListener('ik:cart-updated',event=>{if(Array.isArray(event.detail?.cart?.items))this.cartItems=event.detail.cart.items;this.schedule();},{signal});
      this.observer=new MutationObserver(()=>this.schedule());if(this.selection)this.observer.observe(this.selection,{attributes:true,attributeFilter:['variant']});
      this.update();
    }
    disconnectedCallback(){this.events?.abort();this.observer?.disconnect();cancelAnimationFrame(this.frame);this.form?.classList.remove('ik-product-backorder');for(const item of this.hiddenStock||[])item.classList.remove('ik-stock-backorder-hidden');this.ready=false;}
    schedule(){cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>this.update());}
    update(){
      const id=this.selection?.getAttribute('variant')||this.form.querySelector('[name="id"]')?.value||this.data.selected;
      let variant=this.data.variants.find(item=>String(item.id)===String(id));
      const cartVariant=this.cartItems.find(item=>String(item.variant_id??item.id)===String(id));
      if(variant&&cartVariant&&Number.isFinite(cartVariant.inventory_quantity)&&'inventory_management'in cartVariant)variant={...variant,inventory_quantity:cartVariant.inventory_quantity,inventory_management:cartVariant.inventory_management,inventory_policy:cartVariant.inventory_policy};
      const quantity=this.form.querySelector('[name="quantity"]:not([disabled])')?.value||1;
      const active=backordered(variant,quantity,this.cartItems);this.dataset.backorder=String(active);this.hidden=!active;this.form.classList.toggle('ik-product-backorder',active);
      for(const item of this.hiddenStock||[])item.classList.remove('ik-stock-backorder-hidden');this.hiddenStock=[];
      if(active)for(const item of this.scope.querySelectorAll('[data-stock-level][data-stock-variant-id]'))if(item.dataset.stockVariantId===String(id)){item.classList.add('ik-stock-backorder-hidden');this.hiddenStock.push(item);}
    }
  }
  customElements.define('ik-product-delivery',ProductDelivery);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["inktkenners-search"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('inktkenners-search')) return;
  const tidy = value => String(value || '').normalize('NFKC').replace(/[\u2010-\u2015]/g, '-').trim().replace(/\s+/g, ' ').replace(/^title:"([^"]+)"$/, '$1').slice(0,120);
  const safeURL = value => { try { const url = new URL(value, location.origin); return url.origin === location.origin ? url.pathname + url.search : null; } catch { return null; } };
  const recentSearches = () => { try { const list = JSON.parse(sessionStorage.getItem('ik_recent_searches_v1') || '[]'); return Array.isArray(list) ? list.filter(value => typeof value === 'string' && value.length < 121).slice(0,4) : []; } catch { return []; } };
  const rememberSearch = value => { const query = tidy(value); if (query.length < 2) return; try { sessionStorage.setItem('ik_recent_searches_v1', JSON.stringify([query, ...recentSearches().filter(item => item.toLowerCase() !== query.toLowerCase())].slice(0,4))); } catch {} };
  const engine = async () => {
    if (customElements.get('ik-catalog')) return customElements.get('ik-catalog');
    let timer;
    try { await Promise.race([customElements.whenDefined('ik-catalog'), new Promise((_, reject) => { timer = setTimeout(() => reject(new Error('search_unavailable')), 6000); })]); }
    finally { clearTimeout(timer); }
    return customElements.get('ik-catalog');
  };
  class InktkennersSearch extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true; this.form = this.querySelector('form'); this.input = this.querySelector('[name=q]'); this.clearButton = this.querySelector('.ik-search__clear'); this.panel = this.querySelector('.ik-search__panel'); this.list = this.querySelector('[role=listbox]'); this.status = this.querySelector('[data-ik-status]'); this.labels = JSON.parse(this.querySelector('[data-ik-labels]').textContent); this.active = -1; this.sequence = 0;
      if (!this.input.value && location.pathname.replace(/\/$/,'').endsWith('/pages/search-results')) this.input.value = tidy(new URL(location.href).searchParams.get('q') || '');
      this.input.value = tidy(this.input.value); this.clearButton.hidden = !this.input.value;
      this.events = new AbortController(); const signal = this.events.signal;
      this.input.addEventListener('input', () => {
        this.cancel(); this.clearButton.hidden = !this.input.value; this.resetActive();
        const query = tidy(this.input.value);
        if (query.length < 2) { this.browse(); return; }
        this.render({}, query, this.labels.loading); this.timer = setTimeout(() => this.search(), 140);
      }, {signal});
      this.input.addEventListener('focus', () => { this.preload(); if (tidy(this.input.value).length >= 2) this.search(); else this.browse(); }, {signal});
      this.clearButton.addEventListener('click', () => { this.cancel(); this.input.value = ''; this.clearButton.hidden = true; this.input.focus(); this.browse(); }, {signal});
      this.form.addEventListener('submit', event => {
        event.preventDefault(); event.stopImmediatePropagation(); const query = tidy(this.input.value);
        if (!query) { this.input.focus(); this.browse(); return; }
        rememberSearch(query); this.input.value = query; HTMLFormElement.prototype.submit.call(this.form);
      }, {capture:true, signal});
      this.list.addEventListener('mousedown', event => { if (event.button === 0 && event.target.closest('a[href]')) event.preventDefault(); }, {signal});
      this.list.addEventListener('click', event => { if (event.target.closest('a')) rememberSearch(this.input.value); }, {signal});
      this.input.addEventListener('keydown', event => this.keydown(event), {signal});
      this.addEventListener('focusout', () => queueMicrotask(() => { if (!this.contains(document.activeElement)) this.close(); }), {signal});
      document.addEventListener('pointerdown', event => { if (!this.contains(event.target)) this.close(); }, {signal});
    }
    disconnectedCallback() { this.events?.abort(); this.cancel(); this.ready = false; }
    cancel() { clearTimeout(this.timer); this.sequence++; }
    resetActive() { this.active = -1; this.input.removeAttribute('aria-activedescendant'); this.list.querySelectorAll('[role=option]').forEach(option => option.setAttribute('aria-selected','false')); }
    open() { this.panel.hidden = false; this.input.setAttribute('aria-expanded','true'); }
    close() { this.cancel(); this.panel.hidden = true; this.input.setAttribute('aria-expanded','false'); this.resetActive(); this.status.textContent = ''; }
    url(query) { return this.form.action + '?' + new URLSearchParams({q:tidy(query)}); }
    async preload() { try { const Catalog = await engine(); await Catalog.loadSearch('', this.dataset.root); } catch {} }
    browse() {
      const recent = recentSearches().map(query => ({title:query, url:this.url(query)}));
      const examples = ['HP 953', 'Canon TS5350', 'Brother LC3219', 'Epson 604'].map(query => ({title:query, url:this.url(query)}));
      this.render({recent, examples:recent.length ? [] : examples}, '', this.labels.hint);
    }
    async search() {
      this.cancel(); const sequence = this.sequence; const query = tidy(this.input.value);
      if (query.length < 2) return this.browse();
      this.render({}, query, this.labels.loading);
      try {
        const Catalog = await engine(); const products = await Catalog.loadSearch(query, this.dataset.root);
        if (sequence !== this.sequence || !this.isConnected || query !== tidy(this.input.value)) return;
        const rows = Catalog.searchRows(Catalog.productRows(products), query);
        const printers = Catalog.printerMatches(products, query).slice(0,3).map(printer => ({...printer, detail:this.labels.printer_action}));
        const matched = rows.slice(0,6).map(row => ({title:row.product.title, detail:row.variant.title === 'Default Title' ? '' : row.variant.title, url:row.product.url + '?' + new URLSearchParams({variant:row.variant.id}), price:row.variant.price, image:row.variant.image, available:row.variant.available, backorder:Catalog.backordered(row.variant)}));
        this.render({products:matched, printers, printerFirst:printers.some(printer => printer.exact)}, query);
      } catch {
        if (sequence === this.sequence && this.isConnected) this.render({}, query, this.labels.error);
      }
    }
    render(results, query, message) {
      this.list.replaceChildren(); this.resetActive(); let count = 0;
      if (message) { const hint = document.createElement('p'); hint.className = 'ik-search__message'; hint.setAttribute('role','presentation'); hint.textContent = message; this.list.append(hint); }
      const types = results.printerFirst ? ['recent','examples','printers','products'] : ['recent','examples','products','printers'];
      for (const type of types) {
        const items = results[type] || []; if (!items.length) continue;
        const group = document.createElement('div'); group.setAttribute('role','group'); group.setAttribute('aria-label',this.labels[type]);
        const heading = document.createElement('p'); heading.className = 'ik-search__heading'; heading.setAttribute('role','presentation'); heading.textContent = this.labels[type]; group.append(heading);
        for (const item of items) {
          const url = safeURL(item.url); if (!url) continue;
          const link = document.createElement('a'); link.href = url; link.className = 'ik-search__option'; link.id = this.list.id + '-' + count++; link.setAttribute('role','option'); link.setAttribute('aria-selected','false'); link.tabIndex = -1;
          if (type === 'products' && item.image) { const img = document.createElement('img'); const imageURL = new URL(item.image, location.origin); imageURL.searchParams.set('width','96'); img.src = imageURL.href; img.alt = ''; img.width = 44; img.height = 44; img.loading = 'lazy'; link.append(img); }
          const label = document.createElement('span'); label.className = 'ik-search__label'; label.textContent = item.title;
          if (item.detail) { const detail = document.createElement('span'); detail.className = 'ik-search__detail'; detail.textContent = item.detail; label.append(detail); }
          if (type === 'products' && Number.isFinite(Number(item.price))) { const price = document.createElement('span'); price.className = 'ik-search__price'; price.textContent = new Intl.NumberFormat(this.dataset.locale, {style:'currency',currency:this.dataset.currency}).format(Number(item.price) / 100) + (item.available === false ? ' · ' + this.labels.sold_out : ''); label.append(price); }
          if (type === 'products' && item.backorder) { const delivery = document.createElement('span'); delivery.className = 'ik-search__detail ik-search__delivery'; delivery.textContent = this.labels.backorder; label.append(delivery); }
          link.append(label); group.append(link);
        }
        this.list.append(group);
      }
      if (!count && !message) { const empty = document.createElement('p'); empty.className = 'ik-search__message'; empty.setAttribute('role','presentation'); empty.textContent = this.labels.none; this.list.append(empty); }
      if (query) { const all = document.createElement('a'); all.className = 'ik-search__option ik-search__all'; all.href = this.url(query); all.textContent = this.labels.all; all.setAttribute('role','option'); all.setAttribute('aria-selected','false'); all.id = this.list.id + '-all'; all.tabIndex = -1; this.list.append(all); }
      this.status.textContent = message || (count ? count + ' ' + this.labels.found : this.labels.none);
      if (document.activeElement === this.input) this.open();
    }
    keydown(event) {
      if (event.key === 'Escape') { event.preventDefault(); this.close(); return; }
      if (event.key === 'Tab') { this.close(); return; }
      const options = [...this.list.querySelectorAll('[role=option]')];
      if ((event.key === 'ArrowDown' || event.key === 'ArrowUp') && options.length) {
        event.preventDefault(); this.open();
        this.active = this.active < 0 ? (event.key === 'ArrowDown' ? 0 : options.length - 1) : (this.active + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length;
        options.forEach((option,index) => option.setAttribute('aria-selected',String(index === this.active)));
        this.input.setAttribute('aria-activedescendant',options[this.active].id); options[this.active].scrollIntoView({block:'nearest'});
      }
      if (event.key === 'Enter' && !this.panel.hidden && this.active >= 0) { event.preventDefault(); options[this.active]?.click(); }
    }
  }
  customElements.define('inktkenners-search', InktkennersSearch);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.grid"] && !Shopify.designMode) return;
  try {
    class LayoutGrid extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachShadowRoots(this);
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return;
      }
      
      element.querySelectorAll("template[shadowrootmode]").forEach(template => {
        const mode = template.getAttribute("shadowrootmode");
        const shadowRoot = template.parentNode.attachShadow({ mode });

        shadowRoot.appendChild(template.content);
        template.remove();
        this.attachShadowRoots(shadowRoot);
      });
    }
  }

  customElements.define('layout-grid', LayoutGrid);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.stack"] && !Shopify.designMode) return;
  try {
    class LayoutStack extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachShadowRoots(this);
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return;
      }
      
      element.querySelectorAll("template[shadowrootmode]").forEach(template => {
        const mode = template.getAttribute("shadowrootmode");
        const shadowRoot = template.parentNode.attachShadow({ mode });

        shadowRoot.appendChild(template.content);
        template.remove();
        this.attachShadowRoots(shadowRoot);
      });
    }
  }

  customElements.define('layout-stack', LayoutStack);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.sticky-scroller"] && !Shopify.designMode) return;
  try {
    class StickyScroller extends HTMLElement {
    constructor() {
      super()
      this.resizeObserver = new ResizeObserver(() => this.recalculateStyles())
      this.abortController = new AbortController()
      this.isScrolling = false
      this.position = 'relative'
      this.lastKnownScrollY = 0
      this.initialTop = 0
      this.currentTop = 0
      this.boundOnScroll = this.onScroll.bind(this)
    }

    connectedCallback() {
      this.inView(this, this.setupObservers.bind(this), { margin: '500px' })
    }

    disconnectedCallback() {
      this.cleanupObservers()
    }

    setupObservers() {
      this.resizeObserver.observe(this)
      window.addEventListener('scroll', this.boundOnScroll, { passive: true, signal: this.abortController.signal })
      return this.cleanupObservers.bind(this)
    }

    cleanupObservers() {
      this.abortController.abort()
      this.resizeObserver.disconnect()
    }

    onScroll() {
      if (!this.isScrolling) {
        requestAnimationFrame(() => {
          this.updatePosition()
          this.isScrolling = false
        })
        this.isScrolling = true
      }
    }

    recalculateStyles() {
      this.style.removeProperty('top')
      const { top, position } = getComputedStyle(this)
      this.initialTop = parseInt(top, 10)
      this.position = position
      this.updatePosition()
    }

    updatePosition() {
      if (this.position !== 'sticky') {
        this.style.removeProperty('top')
        return
      }

      const { top, height } = this.getBoundingClientRect()
      const maxTop = top + window.scrollY - this.offsetTop + this.initialTop
      const minTop = height - window.innerHeight + 20

      this.currentTop += this.lastKnownScrollY - window.scrollY
      this.currentTop = Math.min(Math.max(this.currentTop, -minTop), maxTop, this.initialTop)

      this.lastKnownScrollY = window.scrollY
      this.style.top = `${Math.round(this.currentTop)}px`
    }
    
    /**
     * Original source from https://www.npmjs.com/package/@motionone/dom
     * Usage: https://motion.dev/dom/in-view
     */
    inView(elementOrSelector, onStart, { root, margin: rootMargin, amount = 'any' } = {}) {
      const thresholds = {
        any: 0,
        all: 1
      }

      if (typeof IntersectionObserver === 'undefined') {
        return () => {}
      }

      let elements
      if (typeof elementOrSelector === 'string') {
        elements = document.querySelectorAll(elementOrSelector)
      } else if (elementOrSelector instanceof Element) {
        elements = [elementOrSelector]
      } else {
        elements = Array.from(elementOrSelector || [])
      }

      const activeIntersections = new WeakMap()
      const onIntersectionChange = (entries) => {
        entries.forEach((entry) => {
          const onEnd = activeIntersections.get(entry.target)
          if (entry.isIntersecting === Boolean(onEnd)) return
          if (entry.isIntersecting) {
            const newOnEnd = onStart(entry)
            if (typeof newOnEnd === 'function') {
              activeIntersections.set(entry.target, newOnEnd)
            } else {
              observer.unobserve(entry.target)
            }
          } else if (onEnd) {
            onEnd(entry)
            activeIntersections.delete(entry.target)
          }
        })
      }

      const observer = new IntersectionObserver(onIntersectionChange, {
        root,
        rootMargin,
        threshold: typeof amount === 'number' ? amount : thresholds[amount]
      })

      elements.forEach((element) => observer.observe(element))
      return () => observer.disconnect()
    }
  }

  customElements.define('sticky-scroller', StickyScroller)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay.drawer"] && !Shopify.designMode) return;
  try {
    class OverlayDrawer extends HTMLElement {
    constructor() {
      super();
      
      
      
      // Store arrow functions to ensure same reference for add/remove
    }

    connectedCallback() {
      this.closeButton = null;
      this.triggers = null;
      this.previouslyFocused = document.activeElement;
      this.trapFocusHandlers = {};
      this.abortController = new AbortController();
      this.closeButton = this.querySelector('[data-drawer-close-button]');
      this.triggers = document.querySelectorAll(
        `[data-open-drawer="${this.id}"]`
      );

      const signal = this.abortController.signal;
      
      this.moveToBody();

      this.closeButton.addEventListener('click', () => this.close(), { signal });
      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.open();
        }, { signal });
      });
      document.addEventListener('keydown', (event) => this.handleKeydown(event), { signal });
      this.addEventListener('click', (event) => this.handleOverlayClick(event), { signal });
    }

    disconnectedCallback() {
      this.abortController.abort();
    }

    open() {
      this.previouslyFocused = document.activeElement;
      
      this.setAttribute('open', 'true');
      this.trapFocus(this);
    }

    close() {
      this.setAttribute('open', 'false');
      this.removeTrapFocus(this.previouslyFocused);
    }

    moveToBody() {
      if (this.parentNode === document.body) return;
      
      // Store the original parent and next sibling for potential restoration
      this.originalParent = this.parentNode;
      this.originalNextSibling = this.nextSibling;
      
      // Move the element to the body
      document.body.appendChild(this);
    }

    handleOverlayClick(event) {
      if (event.target === this) this.close();
    }

    handleKeydown(event) {
      if (event.key === 'Escape' && this.getAttribute('open') === 'true') {
        this.close();
      }
    }

    removeTrapFocus(elementToFocus = null) {
      if (this.trapFocusAbortController) {
        this.trapFocusAbortController.abort();
        this.trapFocusAbortController = null;
      }

      if (elementToFocus) {
        try {
          elementToFocus.focus({ preventScroll: true })
        } catch (e) {
          elementToFocus.focus()
        }
      }
    }

    forceFocus(element, options = {}) {
      let savedTabIndex = element.tabIndex

      element.tabIndex = -1
      element.dataset.tabIndex = savedTabIndex
      element.focus()
      if (typeof options.className !== 'undefined') {
        element.classList.add(options.className)
      }
      element.addEventListener('blur', callback)

      function callback(event) {
        event.target.removeEventListener(event.type, callback)

        element.tabIndex = savedTabIndex
        delete element.dataset.tabIndex
        if (typeof options.className !== 'undefined') {
          element.classList.remove(options.className)
        }
      }
    }

    focusable(container) {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      )
    }

    trapFocus(container, options = {}) {
      let elements = this.focusable(container)
      let elementToFocus = options.elementToFocus || container
      let first = elements[0]
      let last = elements[elements.length - 1]

      this.removeTrapFocus()

      // Create new AbortController for focus trap events
      this.trapFocusAbortController = new AbortController();
      const signal = this.trapFocusAbortController.signal;

      this.trapFocusHandlers.focusin = function (event) {
        if (container !== event.target && !container.contains(event.target)) {
          this.forceFocus(first || container, options)
        }

        if (event.target !== container && event.target !== last && event.target !== first) return
        document.addEventListener('keydown', this.trapFocusHandlers.keydown, { signal })
      }.bind(this)

      this.trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', this.trapFocusHandlers.keydown)
      }.bind(this)

      this.trapFocusHandlers.keydown = function (event) {
        if (event.keyCode !== 9) return // If not TAB key

        // On the last focusable element and tab forward, focus the first element.
          if (event.target === last && !event.shiftKey) {
        event.preventDefault()
        this.forceFocus(first || container, options)
      }

        //  On the first focusable element and tab backward, focus the last element.
          if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault()
        this.forceFocus(last || container, options)
      }
      }.bind(this)

      document.addEventListener('focusout', this.trapFocusHandlers.focusout, { signal })
      document.addEventListener('focusin', this.trapFocusHandlers.focusin, { signal })

      this.forceFocus(elementToFocus, options)
    }
  }

  customElements.define('overlay-drawer', OverlayDrawer);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay.lightbox"] && !Shopify.designMode) return;
  try {
    class OverlayLightbox extends HTMLElement {
    // Static registry to track all lightbox instances
    static registry = new Map();
    // Track which groups have been prefetched
    static prefetchedGroups = new Set();

    constructor() {
      super();
      this.trigger = null;
      this.template = null;
      this.overlay = null;
      this.closeBtn = null;
      this.prevBtn = null;
      this.nextBtn = null;
      this.group = this.dataset.group;
      this.groupItems = [];
      this.currentIndex = 0;

      // Register this instance
      if (this.group) { 
        if (!OverlayLightbox.registry.has(this.group)) {
          OverlayLightbox.registry.set(this.group, []);
        }
        OverlayLightbox.registry.get(this.group).push(this);
      }
    }

    connectedCallback() {
      // Initialize elements when connected to DOM
      this.trigger = this.querySelector('.overlay-lightbox__trigger');
      this.template = this.querySelector('.overlay-lightbox__template');
      this.init();
    }

    init() {
      // Open lightbox on trigger click
      if (this.trigger) {
        this.trigger.addEventListener('click', (e) => {
          e.preventDefault();
          this.openLightbox();
        });
      }


      // Handle ESC key globally
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) {
          this.closeLightbox();
        } else if (this.isOpen() && this.group) {
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.navigateToPrevious();
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.navigateToNext();
          }
        }
      });
    }

    openLightbox() {
      // Create overlay if it doesn't exist
      if (!this.overlay) {
        this.createOverlay();
      }

      this.overlay.classList.add('overlay-lightbox__overlay--open');
      document.body.style.overflow = 'hidden';

      // If this is part of a group, find all group items
      if (this.group) {
        this.findGroupItems();

        // Prefetch images for the group
        this.prefetchGroupImages();

        // Add single-item class if there's only one item in the group
        if (this.groupItems.length <= 1) {
          this.overlay.classList.add('overlay-lightbox__overlay--single-item');
        } else {
          this.overlay.classList.remove('overlay-lightbox__overlay--single-item');
        }
      } else {
        // No group, so hide navigation buttons
        this.overlay.classList.add('overlay-lightbox__overlay--single-item');
      }
    }

    createOverlay() {
      // Check if template exists
      if (!this.template) {
        console.error('OverlayLightbox: Template not found');
        return;
      }

      // Clone the template content
      this.overlay = this.template.content.cloneNode(true).querySelector('.overlay-lightbox__overlay');
      
      // Check if overlay was created successfully
      if (!this.overlay) {
        console.error('OverlayLightbox: Overlay element not found in template');
        return;
      }
      
      // Get references to buttons
      this.closeBtn = this.overlay.querySelector('.lightbox-close');
      this.prevBtn = this.overlay.querySelector('.overlay-lightbox__nav--prev');
      this.nextBtn = this.overlay.querySelector('.overlay-lightbox__nav--next');

      // Add event listeners
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.closeLightbox();
        });
      }

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.navigateToPrevious();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.navigateToNext();
        });
      }

      // Close lightbox when clicking outside content
      if (this.overlay) {
        this.overlay.addEventListener('click', (e) => {
          if (e.target === this.overlay) {
            this.closeLightbox();
          }
        });
      }

      // Append to body
      if (this.overlay) {
        document.body.appendChild(this.overlay);
      }
    }

    closeLightbox() {
      if (this.overlay) {
        this.overlay.classList.remove('overlay-lightbox__overlay--open');
        this.overlay.classList.remove('overlay-lightbox__overlay--single-item');
        
        // Remove overlay immediately
        if (this.overlay.parentNode) {
          this.overlay.parentNode.removeChild(this.overlay);
          this.overlay = null;
          this.closeBtn = null;
          this.prevBtn = null;
          this.nextBtn = null;
        }
      }
      
      document.body.style.overflow = '';
    }


    findGroupItems() {
      // Use the static registry to find group items
      this.groupItems = OverlayLightbox.registry.get(this.group) || [];
      this.currentIndex = this.groupItems.indexOf(this);
    }

    navigateToPrevious() {
      if (!this.group || this.groupItems.length <= 1) return;

      let targetIndex = this.currentIndex - 1;
      if (targetIndex < 0) {
        // Loop to last item
        targetIndex = this.groupItems.length - 1;
      }

      const targetLightbox = this.groupItems[targetIndex];
      if (targetLightbox) {
        this.switchToLightbox(targetLightbox);
      }
    }

    navigateToNext() {
      if (!this.group || this.groupItems.length <= 1) return;

      let targetIndex = this.currentIndex + 1;
      if (targetIndex >= this.groupItems.length) {
        // Loop to first item
        targetIndex = 0;
      }

      const targetLightbox = this.groupItems[targetIndex];
      if (targetLightbox) {
        this.switchToLightbox(targetLightbox);
      }
    }

    switchToLightbox(targetLightbox) {
      // Close current lightbox
      this.closeLightbox();
      
      // Open target lightbox immediately
      targetLightbox.openLightbox();
    }

    prefetchGroupImages() {
      // Only prefetch once per group
      if (this.group && !OverlayLightbox.prefetchedGroups.has(this.group)) {
        OverlayLightbox.prefetchedGroups.add(this.group);
        
        this.groupItems.forEach(lightbox => {
          // Find all images in this lightbox's content
          const images = lightbox.querySelectorAll('img');
          images.forEach(img => {
            // Prefetch the largest available image
            this.prefetchLargestImage(img);
          });
        });
      }
    }

    prefetchLargestImage(img) {
      // Try to get the largest image from srcset first
      if (img.srcset) {
        const srcsetUrls = img.srcset.split(',').map(src => src.trim().split(' ')[0]);
        // Find the largest size (highest number in the URL)
        let largestUrl = img.src;
        let largestSize = 0;
        
        srcsetUrls.forEach(url => {
          const size = this.extractImageSize(url);
          if (size > largestSize) {
            largestSize = size;
            largestUrl = url;
          }
        });
        
        this.prefetchImage(largestUrl);
      } else {
        // No srcset, try to get largest size from original URL
        const largestUrl = this.getLargestImageUrl(img.src);
        this.prefetchImage(largestUrl);
      }
    }

    extractImageSize(url) {
      try {
        const urlObj = new URL(url);
        
        // Check for width parameter
        if (urlObj.searchParams.has('width')) {
          return parseInt(urlObj.searchParams.get('width')) || 0;
        }
        
        // Check for underscore format (image_2400x.jpg)
        const pathParts = urlObj.pathname.split('_');
        if (pathParts.length > 1) {
          const sizeMatch = pathParts[pathParts.length - 1].match(/(\d+)x/);
          if (sizeMatch) {
            return parseInt(sizeMatch[1]) || 0;
          }
        }
      } catch (e) {
        // URL parsing failed
      }
      
      return 0;
    }

    getLargestImageUrl(originalUrl) {
      try {
        const url = new URL(originalUrl);
        
        // Handle Shopify image URLs - try to get 2400px version
        if (url.searchParams.has('width')) {
          url.searchParams.set('width', '2400');
          return url.toString();
        } else if (url.pathname.includes('_')) {
          // Handle Shopify's underscore format
          const pathParts = url.pathname.split('_');
          if (pathParts.length > 1) {
            const extension = pathParts[pathParts.length - 1].split('.')[1] || 'jpg';
            const newPath = pathParts.slice(0, -1).join('_') + '_2400x.' + extension;
            url.pathname = newPath;
            return url.toString();
          }
        }
      } catch (e) {
        // If URL parsing fails, return original
      }
      
      return originalUrl;
    }

    prefetchImage(url) {
      const prefetchImg = new Image();
      prefetchImg.src = url;
    }

    isOpen() {
      return this.overlay && this.overlay.classList.contains('overlay-lightbox__overlay--open');
    }

    // Clean up when element is removed
    disconnectedCallback() {
      if (this.group) {
        const groupItems = OverlayLightbox.registry.get(this.group);
        if (groupItems) {
          const index = groupItems.indexOf(this);
          if (index > -1) {
            groupItems.splice(index, 1);
          }
          // Remove empty groups
          if (groupItems.length === 0) {
            OverlayLightbox.registry.delete(this.group);
          }
        }
      }
    }
  }

  // Define the custom element
  customElements.define('overlay-lightbox', OverlayLightbox);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product.hot-reload"] && !Shopify.designMode) return;
  try {
    class ProductHotReload extends HTMLElement {
    constructor() {
      super();
      this.cache = new Map(); // Cache for pre-fetched content
      this.activeRequests = new Map(); // Track active fetch requests
      this.loadingTimeout = null; // Timeout for loading state
      this.supportsViewTransitions = 'startViewTransition' in document;
      
      this.addEventListener('change', (event) => this.onVariantChange(event));
      this.addEventListener('mouseover', (event) => this.onMouseOver(event));
    }

    showLoadingState() {
      // Start loading state (pulse) after 200ms
      this.loadingTimeout = setTimeout(() => {
        this.classList.add('product-hot-reload--loading');
      }, 200);
    }

    hideLoadingState() {
      // Clear the timeout if it hasn't triggered yet
      if (this.loadingTimeout) {
        clearTimeout(this.loadingTimeout);
        this.loadingTimeout = null;
      }
      
      // Remove loading animation
      this.classList.remove('product-hot-reload--loading');
    }

    buildRequestUrl(input) {
      const productFormElement = input.closest('form');
      const sectionId = this.dataset.sectionId;
      
      // Get dataset values from the input or selected option
      let newProductUrl, optionValueId;
      
      if (input.type === 'radio') {
        newProductUrl = input.dataset.productUrl;
        optionValueId = input.dataset.optionValueId;
      } else if (input.tagName === 'SELECT') {
        const selectedOption = input.options[input.selectedIndex];
        newProductUrl = selectedOption.dataset.productUrl;
        optionValueId = selectedOption.dataset.optionValueId;
      }

      // Get all currently selected values from both radio inputs and select elements
      let selectedOptionValues = [];
      
      // Get values from checked radio inputs
      const checkedRadios = Array.from(productFormElement.querySelectorAll('input[type="radio"]:checked'));
      selectedOptionValues = checkedRadios.map(({ dataset }) => dataset.optionValueId).filter(Boolean);
      
      // Get values from select elements
      const selects = Array.from(productFormElement.querySelectorAll('select'));
      selects.forEach(select => {
        const selectedOption = select.options[select.selectedIndex];
        if (selectedOption && selectedOption.dataset.optionValueId) {
          selectedOptionValues.push(selectedOption.dataset.optionValueId);
        }
      });

      // If we're building for a hover state, replace the current option's value
      if (input.type === 'radio' && !input.checked) {
        const currentOptionName = input.name;
        // Remove any existing selection for this option
        selectedOptionValues = selectedOptionValues.filter(id => {
          const input = productFormElement.querySelector(`input[data-option-value-id="${id}"]`);
          return input && input.name !== currentOptionName;
        });
        // Add the hovered option value
        selectedOptionValues.push(optionValueId);
      }

      const params = selectedOptionValues.length > 0 ? `&option_values=${selectedOptionValues.join(',')}` : '';
      return `${newProductUrl}?section_id=${sectionId}${params}`;
    }

    onMouseOver(event) {
      const label = event.target.closest('label');
      if (!label) return;

      const input = label.querySelector('input[type="radio"]');
      if (!input) return;

      // Don't pre-fetch if already selected
      if (input.checked) return;

      const requestUrl = this.buildRequestUrl(input);

      // Don't prefetch if we already have cached content or an active request
      if (this.cache.has(requestUrl) || this.activeRequests.has(requestUrl)) return;

      // Pre-fetch the content for this option
      this.fetchContent(requestUrl);
    }

    fetchContent(requestUrl) {
      // Create and store the fetch promise
      const fetchPromise = fetch(requestUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          this.cache.set(requestUrl, html);
          this.activeRequests.delete(requestUrl);
          return html;
        })
        .catch((error) => {
          this.activeRequests.delete(requestUrl);
          throw error;
        });

      this.activeRequests.set(requestUrl, fetchPromise);
      return fetchPromise;
    }

    async onVariantChange(event) {
      if (!event.target.hasAttribute('data-product-hot-reload-trigger')) return;

      const optionValueElement = event.target;
      const requestUrl = this.buildRequestUrl(optionValueElement);
      const oldProductUrl = this.dataset.productUrl;
      
      // Get new product URL from the input or selected option
      let newProductUrl;
      if (optionValueElement.type === 'radio') {
        newProductUrl = optionValueElement.dataset.productUrl || oldProductUrl;
      } else if (optionValueElement.tagName === 'SELECT') {
        const selectedOption = optionValueElement.options[optionValueElement.selectedIndex];
        newProductUrl = selectedOption.dataset.productUrl || oldProductUrl;
      } else {
        newProductUrl = oldProductUrl;
      }

      // Start loading state immediately on change event
      this.showLoadingState();

      let html;

      try {
        // Use cached content if available
        if (this.cache.has(requestUrl)) {
          html = this.cache.get(requestUrl);
        }
        // Wait for active request if one exists
        else if (this.activeRequests.has(requestUrl)) {
          html = await this.activeRequests.get(requestUrl);
        }
        // Make new request if no cache or active request
        else {
          html = await this.fetchContent(requestUrl);
        }

        await this.updateProductWithTransition(html, newProductUrl, event.target.id);
      } catch (error) {
        console.error('Error updating product content:', error);
      } finally {
        // Always hide loading state
        this.hideLoadingState();
      }
    }

    async updateProductWithTransition(html, newProductUrl, targetId) {
      const updatedHtml = html.getElementById(this.id);
      
      if (this.supportsViewTransitions) {
        // Use View Transitions API for smooth transitions
        const transition = document.startViewTransition(() => {
          this.innerHTML = updatedHtml.innerHTML;
          this.dataset.productUrl = updatedHtml.dataset.productUrl;
          this.dataset.variantId = updatedHtml.dataset.variantId;
        });

        // Wait for the transition to complete
        await transition.finished;
      } else {
        // Fallback: Update content immediately without animations
        this.innerHTML = updatedHtml.innerHTML;
        this.dataset.productUrl = updatedHtml.dataset.productUrl;
        this.dataset.variantId = updatedHtml.dataset.variantId;
      }

      // Update URL and history
      let url = new URL(newProductUrl, window.location.origin);

      // Preserve all existing URL parameters from the current page
      const currentUrl = new URL(window.location.href);
      for (const [key, value] of currentUrl.searchParams.entries()) {
        // Don't override the variant parameter we're setting
        if (key !== 'variant') {
          url.searchParams.set(key, value);
        }
      }

      // Add variant param if variantId exists
      url.searchParams.set('variant', this.dataset.variantId);

      // Push new state to browser history
      window.history.pushState({}, '', url.toString());

      // Focus the input for the last clicked option value
      this.querySelector(`#${targetId}`).focus();
    }
  }

  customElements.define('product-hot-reload', ProductHotReload);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["section.flex-pdp.gift-recipient"] && !Shopify.designMode) return;
  try {
    class GiftRecipientForm extends HTMLElement {
    constructor() {
      super()
      this.checkboxInput = this.querySelector('.gift-recipient-form__checkbox input[type="checkbox"]')
      this.emailInput = this.querySelector('.gift-recipient-form__email')
      this.nameInput = this.querySelector('.gift-recipient-form__name')
      this.messageInput = this.querySelector('.gift-recipient-form__message')
      this.dateInput = this.querySelector('.gift-recipient-form__date')
      this.addEventListener('change', () => this.onChange())
      this.recipientFields = this.querySelector('.recipient-fields')

      this.checkboxInput.addEventListener('change', () => {
        event.stopPropagation()
        this.recipientFields.style.display = this.checkboxInput.checked ? 'block' : 'none'
      })
    }

    connectedCallback() {
      this.abortController = new AbortController()

      document.addEventListener('product-form:submit:error', (event) => {
        if (event.target.form.id === this.dataset.formId) {
          this.displayErrorMessage(event.detail.errorMessage)
        }
      }, { signal: this.abortController.signal })

      document.addEventListener('product-form:submit:success', (event) => {
        if (event.target.form.id === this.dataset.formId) {
          this.clearInputFields()
          this.clearErrorMessage()
        }
      }, { signal: this.abortController.signal })
    }

    disconnectedCallback() {
      this.abortController.abort()
    }

    onChange() {
      if (!this.checkboxInput.checked) {
        this.clearInputFields()
        this.clearErrorMessage()
      }
    }

    clearInputFields() {
      for (const element of this.querySelectorAll('input')) {
        element.value = ''
      }
    }

    displayErrorMessage(body) {
      this.clearErrorMessage()
      if (body) {
        return Object.entries(body).forEach(([key, value]) => {
          const inputElement = this[`${key}Input`]
          if (!inputElement) {
            return
          }

          inputElement.setAttribute('aria-invalid', true)
        })
      }
    }

    clearErrorMessage() {
      for (const inputElement of this.querySelectorAll('input')) {
        inputElement.setAttribute('aria-invalid', false)
        inputElement.removeAttribute('aria-describedby')
      }
    }
  }

  customElements.define('gift-recipient-form', GiftRecipientForm)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["section.flex-pdp.media-gallery"] && !Shopify.designMode) return;
  try {
    class MediaGalleryElement extends HTMLElement {
    constructor() {
      super();
      this.slides = this.querySelectorAll('.media-gallery__slide');
      this.thumbs = this.querySelectorAll('.media-gallery__thumb');
      this.prevBtn = this.querySelector('.media-gallery__nav--prev');
      this.nextBtn = this.querySelector('.media-gallery__nav--next');
      this.mainContainer = this.querySelector('.media-gallery__main');
      this.currentIndex = 0;
      this.isAnimating = false;
      this.isNaturalAspectRatio = this.mainContainer?.getAttribute('data-aspect-ratio') === 'initial';

      // Touch/swipe handling
      this.touchStartX = 0;
      this.touchStartY = 0;
      this.touchEndX = 0;
      this.touchEndY = 0;
      this.minSwipeDistance = 50;
    }

    connectedCallback() {
      this.init();
    }

    init() {
      // Adjust container height for natural aspect ratio
      if (this.isNaturalAspectRatio) {
        this.adjustContainerHeight(true); // Disable transition for initial setup

        // Set up resize observer for images that might load asynchronously
        this.setupResizeObserver();
      }

      // Add click handlers to thumbnails
      this.thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => {
          const direction = index > this.currentIndex ? 'next' : 'prev';
          this.goToSlide(index, direction);
        });
      });

      // Add click handlers to navigation buttons
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.previousSlide();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.nextSlide();
        });
      }

      // Add keyboard navigation
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.previousSlide();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.nextSlide();
        }
      });

      // Make the gallery focusable for keyboard navigation
      this.setAttribute('tabindex', '0');

      // Add touch/swipe handlers
      this.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: true });
      this.addEventListener('touchend', this.handleTouchEnd.bind(this), { passive: true });
      this.addEventListener('touchmove', this.handleTouchMove.bind(this), { passive: true });

      // Ensure only the initial active slide can play
      this.pauseNonActiveSlides();
      this.autoplayActiveSlideIfEligible();
    }

    goToSlide(index, direction = 'next') {
      if (index < 0 || index >= this.slides.length) return;
      if (index === this.currentIndex) return;
      if (this.isAnimating) return;

      const currentSlide = this.slides[this.currentIndex];
      const targetSlide = this.slides[index];

      // Before animating, pause non-target slides
      this.pauseAllMediaExceptInSlide(targetSlide);

      // Reset all slides
      this.resetSlides();

      // Position slides for animation
      this.positionSlidesForAnimation(currentSlide, targetSlide, direction);

      // Update UI state
      this.updateThumbnails(index);
      this.currentIndex = index;

      // Start animation after positioning is applied
      this.animateSlides(currentSlide, targetSlide, direction);

      // Adjust container height for natural aspect ratio after slide change
      if (this.isNaturalAspectRatio) {
        setTimeout(() => {
          this.adjustContainerHeight();
        }, 50); // Small delay to ensure slide is positioned
      }
    }

    resetSlides() {
      this.slides.forEach(slide => {
        slide.classList.remove('media-gallery__slide--prev', 'media-gallery__slide--next');
      });
    }

    positionSlidesForAnimation(currentSlide, targetSlide, direction) {
      // Remove animation class from all slides during positioning
      this.slides.forEach(slide => {
        slide.classList.remove('media-gallery__slide--is-animating');
      });

      if (direction === 'next') {
        // Next: target and others on right, current stays in center
        targetSlide.style.transform = 'translateX(100%)';
        this.slides.forEach(slide => {
          if (slide !== currentSlide && slide !== targetSlide) {
            slide.style.transform = 'translateX(100%)';
          }
        });
      } else {
        // Previous: target and others on left, current stays in center
        targetSlide.style.transform = 'translateX(-100%)';
        this.slides.forEach(slide => {
          if (slide !== currentSlide && slide !== targetSlide) {
            slide.style.transform = 'translateX(-100%)';
          }
        });
      }
    }

    updateThumbnails(activeIndex) {
      this.thumbs[this.currentIndex].classList.remove('media-gallery__thumb--active');
      this.thumbs[activeIndex].classList.add('media-gallery__thumb--active');
    }

    adjustContainerHeight(disableTransition = false) {
      if (!this.isNaturalAspectRatio || !this.mainContainer) return;

      const activeSlide = this.slides[this.currentIndex];
      if (!activeSlide) return;

      // Disable transition if requested (for initial setup)
      if (disableTransition) {
        this.mainContainer.classList.add('media-gallery__main--no-transition');
      }

      // Find the image in the active slide
      const img = activeSlide.querySelector('img');
      if (!img) return;

      // Get the image's natural dimensions
      const imgWidth = img.naturalWidth || img.width;
      const imgHeight = img.naturalHeight || img.height;

      if (imgWidth && imgHeight) {
        // Calculate the aspect ratio
        const aspectRatio = imgWidth / imgHeight;

        // Get the container width
        const containerWidth = this.mainContainer.offsetWidth;

        // Calculate the height based on the aspect ratio
        const calculatedHeight = containerWidth / aspectRatio;

        // Set the container height
        this.mainContainer.style.height = calculatedHeight + 'px';
      } else {
        // Fallback: temporarily make the slide visible to measure its height
        const originalOpacity = activeSlide.style.opacity;
        const originalTransform = activeSlide.style.transform;
        activeSlide.style.opacity = '1';
        activeSlide.style.transform = 'translateX(0)';
        activeSlide.style.position = 'relative';
        activeSlide.style.visibility = 'hidden';

        // Get the natural height of the slide content
        const slideHeight = activeSlide.offsetHeight;

        // Restore original styles
        activeSlide.style.opacity = originalOpacity;
        activeSlide.style.transform = originalTransform;
        activeSlide.style.position = '';
        activeSlide.style.visibility = '';

        // Set the container height to match the slide height
        this.mainContainer.style.height = slideHeight + 'px';
      }

      // Re-enable transition after a brief delay
      if (disableTransition) {
        setTimeout(() => {
          this.mainContainer.classList.remove('media-gallery__main--no-transition');
        }, 10);
      }
    }

    setupResizeObserver() {
      if (!this.isNaturalAspectRatio || !window.ResizeObserver) return;

      this.resizeObserver = new ResizeObserver(() => {
        this.adjustContainerHeight();
      });

      // Observe all images in the slides
      this.slides.forEach(slide => {
        const images = slide.querySelectorAll('img');
        images.forEach(img => {
          this.resizeObserver.observe(img);

          // Also listen for load events to recalculate when image loads
          img.addEventListener('load', () => {
            if (slide.classList.contains('media-gallery__slide--active')) {
              this.adjustContainerHeight();
            }
          });
        });
      });
    }

    animateSlides(currentSlide, targetSlide, direction) {
      // Set animation flag
      this.isAnimating = true;

      // Frame 1: Initial positions are already set (no animation class)

      // Frame 2: Add animation class
      requestAnimationFrame(() => {
        currentSlide.classList.add('media-gallery__slide--is-animating');
        targetSlide.classList.add('media-gallery__slide--is-animating');

        // Frame 3: Trigger animation
        requestAnimationFrame(() => {
          // Animate current slide out
          if (direction === 'next') {
            currentSlide.style.transform = 'translateX(-100%)';
          } else {
            currentSlide.style.transform = 'translateX(100%)';
          }

          // Animate target slide in
          targetSlide.style.transform = 'translateX(0)';
          targetSlide.classList.add('media-gallery__slide--active');

          // Clean up after animation
          this.waitForTransition(currentSlide).then(() => {
            this.positionCurrentSlideAfterAnimation(currentSlide, targetSlide, direction);
            this.scrollActiveThumbnailIntoView();
            // Hydrate and autoplay current slide media if eligible and pause others
            this.pauseNonActiveSlides();
            this.autoplayActiveSlideIfEligible();
            // Clear animation flag
            this.isAnimating = false;
          });
        });
      });
    }

    positionCurrentSlideAfterAnimation(currentSlide, targetSlide, direction) {
      // Remove animation class and active class from current slide
      currentSlide.classList.remove('media-gallery__slide--is-animating', 'media-gallery__slide--active');
      targetSlide.classList.remove('media-gallery__slide--is-animating');

      if (direction === 'next') {
        currentSlide.style.transform = 'translateX(100%)';
      } else {
        currentSlide.style.transform = 'translateX(-100%)';
      }

      // Adjust container height for natural aspect ratio after animation
      if (this.isNaturalAspectRatio) {
        this.adjustContainerHeight();
      }
    }

    scrollActiveThumbnailIntoView() {
      this.thumbs[this.currentIndex].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }

    nextSlide() {
      const nextIndex = (this.currentIndex + 1) % this.slides.length;
      this.goToSlide(nextIndex, 'next');
    }

    previousSlide() {
      const prevIndex = this.currentIndex === 0 ? this.slides.length - 1 : this.currentIndex - 1;
      this.goToSlide(prevIndex, 'prev');
    }

    waitForTransition(element) {
      return new Promise((resolve) => {
        const handleTransitionEnd = (e) => {
          if (e.target === element) {
            element.removeEventListener('transitionend', handleTransitionEnd);
            resolve();
          }
        };
        element.addEventListener('transitionend', handleTransitionEnd);
      });
    }

    handleTouchStart(e) {
      if (this.isAnimating) return;

      const touch = e.touches[0];
      this.touchStartX = touch.clientX;
      this.touchStartY = touch.clientY;
    }

    handleTouchMove(e) {
      if (this.isAnimating) return;

      const touch = e.touches[0];
      this.touchEndX = touch.clientX;
      this.touchEndY = touch.clientY;
    }

    handleTouchEnd(e) {
      if (this.isAnimating) return;

      const deltaX = this.touchEndX - this.touchStartX;
      const deltaY = this.touchEndY - this.touchStartY;
      const absDeltaX = Math.abs(deltaX);
      const absDeltaY = Math.abs(deltaY);

      // Only trigger swipe if horizontal movement is greater than vertical
      if (absDeltaX > absDeltaY && absDeltaX > this.minSwipeDistance) {
        if (deltaX > 0) {
          // Swipe right - go to previous slide
          this.previousSlide();
        } else {
          // Swipe left - go to next slide
          this.nextSlide();
        }
      }
    }

    // Utilities for media control
    pauseAllMediaExceptInSlide(slide) {
      const allowed = new Set(slide ? Array.from(slide.querySelectorAll('video-media, model-media')) : []);
      this.querySelectorAll('video-media[playing], model-media[playing]').forEach((el) => {
        if (!allowed.has(el)) {
          el.pause();
        }
      });
    }

    pauseNonActiveSlides() {
      this.slides.forEach((slide, index) => {
        if (index !== this.currentIndex) {
          slide.querySelectorAll('video-media[playing], model-media[playing]').forEach((element) => element.pause());
        }
      });
    }

    autoplayActiveSlideIfEligible() {
      const activeSlide = this.slides[this.currentIndex];
      if (!activeSlide) return;

      const mediaEls = activeSlide.querySelectorAll('video-media, model-media');
      mediaEls.forEach((element) => {
        if (!element.hasAttribute('autoplay')) return;
        if (element.hasAttribute('playing')) return;
        // If already loaded, try immediately; else wait for 'loaded' attribute
        if (element.hasAttribute('loaded')) {
          element.play();
        } else {
          const observer = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
              if (mutation.type === 'attributes' && mutation.attributeName === 'loaded' && element.hasAttribute('loaded')) {
                observer.disconnect();
                element.play();
                break;
              }
            }
          });

          observer.observe(element, { attributes: true, attributeFilter: ['loaded'] });
        }
      });
    }
  }

  // Define the custom element
  customElements.define('media-gallery', MediaGalleryElement);
  } catch(e) { console.error(e); }
})();

})();
